'use strict';

var React = require('react');
var componentsIcon = require('@keytrade/components-icon');
var componentsParagraph = require('@keytrade/components-paragraph');
var componentsTitle = require('@keytrade/components-title');
var componentsLink = require('@keytrade/components-link');
var componentsList = require('@keytrade/components-list');
var componentsButton = require('@keytrade/components-button');
var ReactDOM = require('react-dom');
var componentsCard = require('@keytrade/components-card');
var componentsInputtext = require('@keytrade/components-inputtext');
var componentsRangeindicator = require('@keytrade/components-rangeindicator');
var componentsBbcode = require('@keytrade/components-bbcode');
var componentsLoader = require('@keytrade/components-loader');
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
  cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
  cachedClearTimeout = clearTimeout;
}
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  }
  // if setTimeout wasn't available but was latter defined
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  }
  // if clearTimeout wasn't available but was latter defined
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
function nextTick(fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
}
// v8 likes predictible objects
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};
var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};
function noop$1() {}
var on = noop$1;
var addListener = noop$1;
var once = noop$1;
var off = noop$1;
var removeListener = noop$1;
var removeAllListeners = noop$1;
var emit = noop$1;
function binding(name) {
  throw new Error('process.binding is not supported');
}
function cwd() {
  return '/';
}
function chdir(dir) {
  throw new Error('process.chdir is not supported');
}
function umask() {
  return 0;
}

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
  return new Date().getTime();
};

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp) {
  var clocktime = performanceNow.call(performance) * 1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor(clocktime % 1 * 1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds < 0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds, nanoseconds];
}
var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}
var browser$1 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash(value, length) {
  return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}

/**
 * @param {string} value
 * @return {string}
 */
function trim(value) {
  return value.trim();
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

/**
 * @param {string} value
 * @param {string} search
 * @param {number} position
 * @return {number}
 */
function indexof(value, search, position) {
  return value.indexOf(search, position);
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr(value, begin, end) {
  return value.slice(begin, end);
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen(value) {
  return value.length;
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof(value) {
  return value.length;
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append(value, array) {
  return array.push(value), value;
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine(array, callback) {
  return array.map(callback).join('');
}

/**
 * @param {string[]} array
 * @param {RegExp} pattern
 * @return {string[]}
 */
function filter(array, pattern) {
  return array.filter(function (value) {
    return !match(value, pattern);
  });
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {object[]} siblings
 * @param {number} length
 */
function node(value, root, parent, type, props, children, length, siblings) {
  return {
    value: value,
    root: root,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length,
    return: '',
    siblings: siblings
  };
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy(root, props) {
  return assign(node('', null, null, '', null, null, 0, root.siblings), root, {
    length: -root.length
  }, props);
}

/**
 * @param {object} root
 */
function lift(root) {
  while (root.root) root = copy(root.root, {
    children: [root]
  });
  append(root, root.siblings);
}

/**
 * @return {number}
 */
function char() {
  return character;
}

/**
 * @return {number}
 */
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

/**
 * @return {number}
 */
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

/**
 * @return {number}
 */
function peek() {
  return charat(characters, position);
}

/**
 * @return {number}
 */
function caret() {
  return position;
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice(begin, end) {
  return substr(characters, begin, end);
}

/**
 * @param {number} type
 * @return {number}
 */
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc(value) {
  return characters = '', value;
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace(type) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type) > 2 || token(character) > 3 ? '' : ' ';
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping(index, count) {
  while (--count && next())
  // not 0-9 A-F a-f
  if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter(type) {
  while (next()) switch (character) {
    // ] ) " '
    case type:
      return position;
    // " '
    case 34:
    case 39:
      if (type !== 34 && type !== 39) delimiter(character);
      break;
    // (
    case 40:
      if (type === 41) delimiter(type);
      break;
    // \
    case 92:
      next();
      break;
  }
  return position;
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter(type, index) {
  while (next())
  // //
  if (type + character === 47 + 10) break;
  // /*
  else if (type + character === 42 + 42 && peek() === 47) break;
  return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next());
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier(index) {
  while (!token(peek())) next();
  return slice(index, position);
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile(value) {
  return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value));
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character = 0;
  var type = '';
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters = type;
  while (scanning) switch (previous = character, character = next()) {
    // (
    case 40:
      if (previous != 108 && charat(characters, length - 1) == 58) {
        if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f', abs(index ? points[index - 1] : 0)) != -1) ampersand = -1;
        break;
      }
    // " ' [
    case 34:
    case 39:
    case 91:
      characters += delimit(character);
      break;
    // \t \n \r \s
    case 9:
    case 10:
    case 13:
    case 32:
      characters += whitespace(previous);
      break;
    // \
    case 92:
      characters += escaping(caret() - 1, 7);
      continue;
    // /
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          append(comment(commenter(next(), caret()), root, parent, declarations), declarations);
          break;
        default:
          characters += '/';
      }
      break;
    // {
    case 123 * variable:
      points[index++] = strlen(characters) * ampersand;
    // } ; \0
    case 125 * variable:
    case 59:
    case 0:
      switch (character) {
        // \0 }
        case 0:
        case 125:
          scanning = 0;
        // ;
        case 59 + offset:
          if (ampersand == -1) characters = replace(characters, /\f/g, '');
          if (property > 0 && strlen(characters) - length) append(property > 32 ? declaration(characters + ';', rule, parent, length - 1, declarations) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
          break;
        // @ ;
        case 59:
          characters += ';';
        // { rule/at-rule
        default:
          append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
          if (character === 123) if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);else switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
            // d l m s
            case 100:
            case 108:
            case 109:
            case 115:
              parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
              break;
            default:
              parse(characters, reference, reference, reference, [''], children, 0, points, children);
          }
      }
      index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
      break;
    // :
    case 58:
      length = 1 + strlen(characters), property = previous;
    default:
      if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev() == 125) continue;
      switch (characters += from(character), character * variable) {
        // &
        case 38:
          ampersand = offset > 0 ? 1 : (characters += '\f', -1);
          break;
        // ,
        case 44:
          points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
          break;
        // @
        case 64:
          // -
          if (peek() === 45) characters += delimit(next());
          atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
          break;
        // -
        case 45:
          if (previous === 45 && strlen(characters) == 2) variable = 0;
      }
  }
  return rulesets;
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [''];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i) for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x]))) props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length, siblings);
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @param {object[]} siblings
 * @return {object}
 */
function comment(value, root, parent, siblings) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0, siblings);
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function declaration(value, root, parent, length, siblings) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length, siblings);
}

/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */
function prefix(value, length, children) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // tab-size
    case 4789:
      return MOZ + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // writing-mode
    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
        // default: fallthrough to below
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return WEBKIT + value + MS + value + value;
    // order
    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self
    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/g, '') + (!match(value, /flex-|baseline/) ? MS + 'grid-row-' + replace(value, /flex-|-self/g, '') : '') + value;
    // align-content
    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/g, '') + value;
    // flex-shrink
    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis
    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow
    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // justify-self
    case 4200:
      if (!match(value, /flex-|baseline/)) return MS + 'grid-column-align' + substr(value, length) + value;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return MS + replace(value, 'template-', '') + value;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      if (children && children.some(function (element, index) {
        return length = index, match(element.props, /grid-\w+-end/);
      })) {
        return ~indexof(value + (children = children[length].value), 'span', 0) ? value : MS + replace(value, '-start', '') + value + MS + 'grid-row-span:' + (~indexof(children, 'span', 0) ? match(children, /\d+/) : +match(children, /\d+/) - +match(value, /\d+/)) + ';';
      }
      return MS + replace(value, '-start', '') + value;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return children && children.some(function (element) {
        return match(element.props, /grid-\w+-start/);
      }) ? value : MS + replace(replace(value, '-end', '-span'), 'span ', '') + value;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch
        case 115:
          return ~indexof(value, 'stretch', 0) ? prefix(replace(value, 'stretch', 'fill-available'), length, children) + value : value;
      }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return replace(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function (_, a, b, c, d, e, f) {
        return MS + a + ':' + b + f + (c ? MS + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
      });
    // position: sticky
    case 4949:
      // stick(y)?
      if (charat(value, length + 6) === 121) return replace(value, ':', ':' + WEBKIT) + value;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (charat(value, charat(value, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return replace(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
        // (inline-)?gri(d)
        case 100:
          return replace(value, ':', ':' + MS) + value;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return replace(value, 'scroll-', 'scroll-snap-') + value;
  }
  return value;
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize(children, callback) {
  var output = '';
  for (var i = 0; i < children.length; i++) output += callback(children[i], i, children, callback) || '';
  return output;
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify(element, index, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return '';
    case KEYFRAMES:
      return element.return = element.value + '{' + serialize(element.children, callback) + '}';
    case RULESET:
      if (!strlen(element.value = element.props.join(','))) return '';
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware(collection) {
  var length = sizeof(collection);
  return function (element, index, children, callback) {
    var output = '';
    for (var i = 0; i < length; i++) output += collection[i](element, index, children, callback) || '';
    return output;
  };
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet(callback) {
  return function (element) {
    if (!element.root) if (element = element.return) callback(element);
  };
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element.return) switch (element.type) {
    case DECLARATION:
      element.return = prefix(element.value, element.length, children);
      return;
    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);
    case RULESET:
      if (element.length) return combine(children = element.props, function (value) {
        switch (match(value, callback = /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            lift(copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            }));
            lift(copy(element, {
              props: [value]
            }));
            assign(element, {
              props: filter(children, callback)
            });
            break;
          // :placeholder
          case '::placeholder':
            lift(copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }));
            lift(copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }));
            lift(copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            }));
            lift(copy(element, {
              props: [value]
            }));
            assign(element, {
              props: filter(children, callback)
            });
            break;
        }
        return '';
      });
  }
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var f = "undefined" != typeof browser$1 && undefined !== browser$1.env && (browser$1.env.REACT_APP_SC_ATTR || browser$1.env.SC_ATTR) || "data-styled",
  m = "active",
  y = "data-styled-version",
  v = "6.1.13",
  g = "/*!sc*/\n",
  S = "undefined" != typeof window && "HTMLElement" in window,
  w$1 = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof browser$1 && undefined !== browser$1.env && undefined !== browser$1.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== browser$1.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== browser$1.env.REACT_APP_SC_DISABLE_SPEEDY && browser$1.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof browser$1 && undefined !== browser$1.env && undefined !== browser$1.env.SC_DISABLE_SPEEDY && "" !== browser$1.env.SC_DISABLE_SPEEDY ? "false" !== browser$1.env.SC_DISABLE_SPEEDY && browser$1.env.SC_DISABLE_SPEEDY : "production" !== browser$1.env.NODE_ENV),
  b = {},
  E$1 = /invalid hook call/i,
  N = new Set(),
  P = function (t, n) {
    if ("production" !== browser$1.env.NODE_ENV) {
      var r = n ? ' with the id of "'.concat(n, '"') : "",
        s = "The component ".concat(t).concat(r, " has been created dynamically.\n") + "You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",
        i = console.error;
      try {
        var a = !0;
        console.error = function (t) {
          for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
          E$1.test(t) ? (a = !1, N.delete(s)) : i.apply(void 0, __spreadArray([t], n, !1));
        }, React.useRef(), a && !N.has(s) && (console.warn(s), N.add(s));
      } catch (e) {
        E$1.test(e.message) && N.delete(s);
      } finally {
        console.error = i;
      }
    }
  },
  _ = Object.freeze([]),
  C$1 = Object.freeze({});
function I(e, t, n) {
  return undefined === n && (n = C$1), e.theme !== n.theme && e.theme || t || n.theme;
}
var A$1 = new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]),
  O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  D$1 = /(^-|-$)/g;
function R(e) {
  return e.replace(O, "-").replace(D$1, "");
}
var T = /(a)(d)/gi,
  k = 52,
  j = function (e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function x(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > k; t = t / k | 0) n = j(t % k) + n;
  return (j(t % k) + n).replace(T, "$1-$2");
}
var V,
  F$1 = 5381,
  M = function (e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  z$1 = function (e) {
    return M(F$1, e);
  };
function $(e) {
  return x(z$1(e) >>> 0);
}
function B$1(e) {
  return "production" !== browser$1.env.NODE_ENV && "string" == typeof e && e || e.displayName || e.name || "Component";
}
function L(e) {
  return "string" == typeof e && ("production" === browser$1.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var G = "function" == typeof Symbol && Symbol.for,
  Y = G ? Symbol.for("react.memo") : 60115,
  q = G ? Symbol.for("react.forward_ref") : 60112,
  W = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  },
  H = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  },
  U = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  },
  J = ((V = {})[q] = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  }, V[Y] = U, V);
function X(e) {
  return ("type" in (t = e) && t.type.$$typeof) === Y ? U : "$$typeof" in e ? J[e.$$typeof] : W;
  var t;
}
var Z = Object.defineProperty,
  K = Object.getOwnPropertyNames,
  Q = Object.getOwnPropertySymbols,
  ee = Object.getOwnPropertyDescriptor,
  te = Object.getPrototypeOf,
  ne = Object.prototype;
function re(e, t, n) {
  if ("string" != typeof t) {
    if (ne) {
      var r = te(t);
      r && r !== ne && re(e, r, n);
    }
    var o = K(t);
    Q && (o = o.concat(Q(t)));
    for (var s = X(e), i = X(t), a = 0; a < o.length; ++a) {
      var c = o[a];
      if (!(c in H || n && n[c] || i && c in i || s && c in s)) {
        var l = ee(t, c);
        try {
          Z(e, c, l);
        } catch (e) {}
      }
    }
  }
  return e;
}
function oe(e) {
  return "function" == typeof e;
}
function se(e) {
  return "object" == typeof e && "styledComponentId" in e;
}
function ie(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function ae(e, t) {
  if (0 === e.length) return "";
  for (var n = e[0], r = 1; r < e.length; r++) n += e[r];
  return n;
}
function ce(e) {
  return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function le(e, t, n) {
  if (undefined === n && (n = false), !n && !ce(e) && !Array.isArray(e)) return t;
  if (Array.isArray(t)) for (var r = 0; r < t.length; r++) e[r] = le(e[r], t[r]);else if (ce(t)) for (var r in t) e[r] = le(e[r], t[r]);
  return e;
}
function ue(e, t) {
  Object.defineProperty(e, "toString", {
    value: t
  });
}
var pe = "production" !== browser$1.env.NODE_ENV ? {
  1: "Cannot create styled-component for component: %s.\n\n",
  2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
  9: "Missing document `<head>`\n\n",
  10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
  14: 'ThemeProvider: "theme" prop is required.\n\n',
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
  17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",
  18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"
} : {};
function de() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  for (var n = e[0], r = [], o = 1, s = e.length; o < s; o += 1) r.push(e[o]);
  return r.forEach(function (e) {
    n = n.replace(/%[a-z]/, e);
  }), n;
}
function he(t) {
  for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
  return "production" === browser$1.env.NODE_ENV ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(de.apply(undefined, __spreadArray([pe[t]], n, false)).trim());
}
var fe = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, e.prototype.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, r = n.length, o = r; e >= o;) if ((o <<= 1) < 0) throw he(16, "".concat(e));
        this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
        for (var s = r; s < o; s++) this.groupSizes[s] = 0;
      }
      for (var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++) this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t;
        this.groupSizes[e] = 0;
        for (var o = n; o < r; o++) this.tag.deleteRule(n);
      }
    }, e.prototype.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++) t += "".concat(this.tag.getRule(s)).concat(g);
      return t;
    }, e;
  }(),
  me = 1 << 30,
  ye = new Map(),
  ve = new Map(),
  ge = 1,
  Se = function (e) {
    if (ye.has(e)) return ye.get(e);
    for (; ve.has(ge);) ge++;
    var t = ge++;
    if ("production" !== browser$1.env.NODE_ENV && ((0 | t) < 0 || t > me)) throw he(16, "".concat(t));
    return ye.set(e, t), ve.set(t, e), t;
  },
  we = function (e, t) {
    ge = t + 1, ye.set(e, t), ve.set(t, e);
  },
  be = "style[".concat(f, "][").concat(y, '="').concat(v, '"]'),
  Ee = new RegExp("^".concat(f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),
  Ne = function (e, t, n) {
    for (var r, o = n.split(","), s = 0, i = o.length; s < i; s++) (r = o[s]) && e.registerName(t, r);
  },
  Pe = function (e, t) {
    for (var n, r = (null !== (n = t.textContent) && undefined !== n ? n : "").split(g), o = [], s = 0, i = r.length; s < i; s++) {
      var a = r[s].trim();
      if (a) {
        var c = a.match(Ee);
        if (c) {
          var l = 0 | parseInt(c[1], 10),
            u = c[2];
          0 !== l && (we(u, l), Ne(e, u, c[3]), e.getTag().insertRules(l, o)), o.length = 0;
        } else o.push(a);
      }
    }
  },
  _e = function (e) {
    for (var t = document.querySelectorAll(be), n = 0, r = t.length; n < r; n++) {
      var o = t[n];
      o && o.getAttribute(f) !== m && (Pe(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
  };
function Ce() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var Ie = function (e) {
    var t = document.head,
      n = e || t,
      r = document.createElement("style"),
      o = function (e) {
        var t = Array.from(e.querySelectorAll("style[".concat(f, "]")));
        return t[t.length - 1];
      }(n),
      s = undefined !== o ? o.nextSibling : null;
    r.setAttribute(f, m), r.setAttribute(y, v);
    var i = Ce();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
  },
  Ae = function () {
    function e(e) {
      this.element = Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          if (o.ownerNode === e) return o;
        }
        throw he(17);
      }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return false;
      }
    }, e.prototype.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return t && t.cssText ? t.cssText : "";
    }, e;
  }(),
  Oe = function () {
    function e(e) {
      this.element = Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t);
        return this.element.insertBefore(n, this.nodes[e] || null), this.length++, true;
      }
      return false;
    }, e.prototype.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  De = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, true);
    }, e.prototype.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  Re = S,
  Te = {
    isServer: !S,
    useCSSOMInjection: !w$1
  },
  ke = function () {
    function e(e, n, r) {
      undefined === e && (e = C$1), undefined === n && (n = {});
      var o = this;
      this.options = __assign(__assign({}, Te), e), this.gs = n, this.names = new Map(r), this.server = !!e.isServer, !this.server && S && Re && (Re = false, _e(this)), ue(this, function () {
        return function (e) {
          for (var t = e.getTag(), n = t.length, r = "", o = function (n) {
              var o = function (e) {
                return ve.get(e);
              }(n);
              if (undefined === o) return "continue";
              var s = e.names.get(o),
                i = t.getGroup(n);
              if (undefined === s || !s.size || 0 === i.length) return "continue";
              var a = "".concat(f, ".g").concat(n, '[id="').concat(o, '"]'),
                c = "";
              undefined !== s && s.forEach(function (e) {
                e.length > 0 && (c += "".concat(e, ","));
              }), r += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat(g);
            }, s = 0; s < n; s++) o(s);
          return r;
        }(o);
      });
    }
    return e.registerId = function (e) {
      return Se(e);
    }, e.prototype.rehydrate = function () {
      !this.server && S && _e(this);
    }, e.prototype.reconstructWithOptions = function (n, r) {
      return undefined === r && (r = true), new e(__assign(__assign({}, this.options), n), this.gs, r && this.names || undefined);
    }, e.prototype.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function () {
      return this.tag || (this.tag = (e = function (e) {
        var t = e.useCSSOMInjection,
          n = e.target;
        return e.isServer ? new De(n) : t ? new Ae(n) : new Oe(n);
      }(this.options), new fe(e)));
      var e;
    }, e.prototype.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function (e, t) {
      if (Se(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, e.prototype.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(Se(e), n);
    }, e.prototype.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function (e) {
      this.getTag().clearGroup(Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function () {
      this.tag = undefined;
    }, e;
  }(),
  je = /&/g,
  xe = /^\s*\/\/.*$/gm;
function Ve(e, t) {
  return e.map(function (e) {
    return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function (e) {
      return "".concat(t, " ").concat(e);
    })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = Ve(e.children, t)), e;
  });
}
function Fe(e) {
  var t,
    n,
    r,
    o = C$1,
    s = o.options,
    i = undefined === s ? C$1 : s,
    a = o.plugins,
    c = undefined === a ? _ : a,
    l = function (e, r, o) {
      return o.startsWith(n) && o.endsWith(n) && o.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    },
    u = c.slice();
  u.push(function (e) {
    e.type === RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace(je, n).replace(r, l));
  }), i.prefix && u.push(prefixer), u.push(stringify);
  var p = function (e, o, s, a) {
    undefined === o && (o = ""), undefined === s && (s = ""), undefined === a && (a = "&"), t = a, n = o, r = new RegExp("\\".concat(n, "\\b"), "g");
    var c = e.replace(xe, ""),
      l = compile(s || o ? "".concat(s, " ").concat(o, " { ").concat(c, " }") : c);
    i.namespace && (l = Ve(l, i.namespace));
    var p = [];
    return serialize(l, middleware(u.concat(rulesheet(function (e) {
      return p.push(e);
    })))), p;
  };
  return p.hash = c.length ? c.reduce(function (e, t) {
    return t.name || he(15), M(e, t.name);
  }, F$1).toString() : "", p;
}
var Me = new ke(),
  ze = Fe(),
  $e = /*#__PURE__*/React.createContext({
    shouldForwardProp: undefined,
    styleSheet: Me,
    stylis: ze
  });
$e.Consumer;
function Ge() {
  return React.useContext($e);
}
var qe = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        undefined === t && (t = ze);
        var r = n.name + t.hash;
        e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
      }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, ue(this, function () {
        throw he(12, String(n.name));
      });
    }
    return e.prototype.getName = function (e) {
      return undefined === e && (e = ze), this.name + e.hash;
    }, e;
  }(),
  We = function (e) {
    return e >= "A" && e <= "Z";
  };
function He(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var r = e[n];
    if (1 === n && "-" === r && "-" === e[0]) return e;
    We(r) ? t += "-" + r.toLowerCase() : t += r;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var Ue = function (e) {
    return null == e || false === e || "" === e;
  },
  Je = function (t) {
    var n,
      r,
      o = [];
    for (var s in t) {
      var i = t[s];
      t.hasOwnProperty(s) && !Ue(i) && (Array.isArray(i) && i.isCss || oe(i) ? o.push("".concat(He(s), ":"), i, ";") : ce(i) ? o.push.apply(o, __spreadArray(__spreadArray(["".concat(s, " {")], Je(i), false), ["}"], false)) : o.push("".concat(He(s), ": ").concat((n = s, null == (r = i) || "boolean" == typeof r || "" === r ? "" : "number" != typeof r || 0 === r || n in unitlessKeys || n.startsWith("--") ? String(r).trim() : "".concat(r, "px")), ";")));
    }
    return o;
  };
function Xe(e, t, n, r) {
  if (Ue(e)) return [];
  if (se(e)) return [".".concat(e.styledComponentId)];
  if (oe(e)) {
    if (!oe(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [e];
    var o = e(t);
    return "production" === browser$1.env.NODE_ENV || "object" != typeof o || Array.isArray(o) || o instanceof qe || ce(o) || null === o || console.error("".concat(B$1(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Xe(o, t, n, r);
  }
  var s;
  return e instanceof qe ? n ? (e.inject(n, r), [e.getName(r)]) : [e] : ce(e) ? Je(e) : Array.isArray(e) ? Array.prototype.concat.apply(_, e.map(function (e) {
    return Xe(e, t, n, r);
  })) : [e.toString()];
}
function Ze(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (oe(n) && !se(n)) return false;
  }
  return true;
}
var Ke = z$1(v),
  Qe = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = "production" === browser$1.env.NODE_ENV && (undefined === n || n.isStatic) && Ze(e), this.componentId = t, this.baseHash = M(Ke, t), this.baseStyle = n, ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var r = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
      if (this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) r = ie(r, this.staticRulesId);else {
          var o = ae(Xe(this.rules, e, t, n)),
            s = x(M(this.baseHash, o) >>> 0);
          if (!t.hasNameForId(this.componentId, s)) {
            var i = n(o, ".".concat(s), undefined, this.componentId);
            t.insertRules(this.componentId, s, i);
          }
          r = ie(r, s), this.staticRulesId = s;
        }
      } else {
        for (var a = M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++) {
          var u = this.rules[l];
          if ("string" == typeof u) c += u, "production" !== browser$1.env.NODE_ENV && (a = M(a, u));else if (u) {
            var p = ae(Xe(u, e, t, n));
            a = M(a, p + l), c += p;
          }
        }
        if (c) {
          var d = x(a >>> 0);
          t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), undefined, this.componentId)), r = ie(r, d);
        }
      }
      return r;
    }, e;
  }(),
  et = /*#__PURE__*/React.createContext(undefined);
et.Consumer;
var ot = {},
  st = new Set();
function it(e, o, s) {
  var i = se(e),
    a = e,
    c = !L(e),
    p = o.attrs,
    d = undefined === p ? _ : p,
    h = o.componentId,
    f = undefined === h ? function (e, t) {
      var n = "string" != typeof e ? "sc" : R(e);
      ot[n] = (ot[n] || 0) + 1;
      var r = "".concat(n, "-").concat($(v + n + ot[n]));
      return t ? "".concat(t, "-").concat(r) : r;
    }(o.displayName, o.parentComponentId) : h,
    m = o.displayName,
    y = undefined === m ? function (e) {
      return L(e) ? "styled.".concat(e) : "Styled(".concat(B$1(e), ")");
    }(e) : m,
    g = o.displayName && o.componentId ? "".concat(R(o.displayName), "-").concat(o.componentId) : o.componentId || f,
    S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d,
    w = o.shouldForwardProp;
  if (i && a.shouldForwardProp) {
    var b = a.shouldForwardProp;
    if (o.shouldForwardProp) {
      var E = o.shouldForwardProp;
      w = function (e, t) {
        return b(e, t) && E(e, t);
      };
    } else w = b;
  }
  var N = new Qe(s, g, i ? a.componentStyle : undefined);
  function O(e, o) {
    return function (e, o, s) {
      var i = e.attrs,
        a = e.componentStyle,
        c = e.defaultProps,
        p = e.foldedComponentIds,
        d = e.styledComponentId,
        h = e.target,
        f = React.useContext(et),
        m = Ge(),
        y = e.shouldForwardProp || m.shouldForwardProp;
      "production" !== browser$1.env.NODE_ENV && React.useDebugValue(d);
      var v = I(o, f, c) || C$1,
        g = function (e, n, r) {
          for (var o, s = __assign(__assign({}, n), {
              className: undefined,
              theme: r
            }), i = 0; i < e.length; i += 1) {
            var a = oe(o = e[i]) ? o(s) : o;
            for (var c in a) s[c] = "className" === c ? ie(s[c], a[c]) : "style" === c ? __assign(__assign({}, s[c]), a[c]) : a[c];
          }
          return n.className && (s.className = ie(s.className, n.className)), s;
        }(i, o, v),
        S = g.as || h,
        w = {};
      for (var b in g) undefined === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y || "development" !== browser$1.env.NODE_ENV || isPropValid(b) || st.has(b) || !A$1.has(S) || (st.add(b), console.warn('styled-components: it looks like an unknown prop "'.concat(b, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var E = function (e, t) {
        var n = Ge(),
          r = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
        return "production" !== browser$1.env.NODE_ENV && React.useDebugValue(r), r;
      }(a, g);
      "production" !== browser$1.env.NODE_ENV && e.warnTooManyClasses && e.warnTooManyClasses(E);
      var N = ie(p, d);
      return E && (N += " " + E), g.className && (N += " " + g.className), w[L(S) && !A$1.has(S) ? "class" : "className"] = N, w.ref = s, /*#__PURE__*/React.createElement(S, w);
    }(D, e, o);
  }
  O.displayName = y;
  var D = /*#__PURE__*/React.forwardRef(O);
  return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
    get: function () {
      return this._foldedDefaultProps;
    },
    set: function (e) {
      this._foldedDefaultProps = i ? function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        for (var r = 0, o = t; r < o.length; r++) le(e, o[r], true);
        return e;
      }({}, a.defaultProps, e) : e;
    }
  }), "production" !== browser$1.env.NODE_ENV && (P(y, g), D.warnTooManyClasses = function (e, t) {
    var n = {},
      r = false;
    return function (o) {
      if (!r && (n[o] = true, Object.keys(n).length >= 200)) {
        var s = t ? ' with the id of "'.concat(t, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(e).concat(s, ".\n") + "Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = true, n = {};
      }
    };
  }(y, g)), ue(D, function () {
    return ".".concat(D.styledComponentId);
  }), c && re(D, e, {
    attrs: true,
    componentStyle: true,
    displayName: true,
    foldedComponentIds: true,
    shouldForwardProp: true,
    styledComponentId: true,
    target: true
  }), D;
}
function at(e, t) {
  for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) n.push(t[r], e[r + 1]);
  return n;
}
var ct = function (e) {
  return Object.assign(e, {
    isCss: true
  });
};
function lt(t) {
  for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
  if (oe(t) || ce(t)) return ct(Xe(at(_, __spreadArray([t], n, true))));
  var o = t;
  return 0 === n.length && 1 === o.length && "string" == typeof o[0] ? Xe(o) : ct(Xe(at(o, n)));
}
function ut(n, r, o) {
  if (undefined === o && (o = C$1), !r) throw he(1, r);
  var s = function (t) {
    for (var s = [], i = 1; i < arguments.length; i++) s[i - 1] = arguments[i];
    return n(r, o, lt.apply(undefined, __spreadArray([t], s, false)));
  };
  return s.attrs = function (e) {
    return ut(n, r, __assign(__assign({}, o), {
      attrs: Array.prototype.concat(o.attrs, e).filter(Boolean)
    }));
  }, s.withConfig = function (e) {
    return ut(n, r, __assign(__assign({}, o), e));
  }, s;
}
var pt = function (e) {
    return ut(it, e);
  },
  dt = pt;
A$1.forEach(function (e) {
  dt[e] = pt(e);
});
var ht = function () {
  function e(e, t) {
    this.rules = e, this.componentId = t, this.isStatic = Ze(e), ke.registerId(this.componentId + 1);
  }
  return e.prototype.createStyles = function (e, t, n, r) {
    var o = r(ae(Xe(this.rules, t, n, r)), ""),
      s = this.componentId + e;
    n.insertRules(s, s, o);
  }, e.prototype.removeStyles = function (e, t) {
    t.clearRules(this.componentId + e);
  }, e.prototype.renderStyles = function (e, t, n, r) {
    e > 2 && ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
  }, e;
}();
function ft(n) {
  for (var o = [], s = 1; s < arguments.length; s++) o[s - 1] = arguments[s];
  var i = lt.apply(undefined, __spreadArray([n], o, false)),
    a = "sc-global-".concat($(JSON.stringify(i))),
    c = new ht(i, a);
  "production" !== browser$1.env.NODE_ENV && P(a);
  var l = function (e) {
    var n = Ge(),
      o = React.useContext(et),
      s = React.useRef(n.styleSheet.allocateGSInstance(a)).current;
    return "production" !== browser$1.env.NODE_ENV && React.Children.count(e.children) && console.warn("The global style component ".concat(a, " was given child JSX. createGlobalStyle does not render children.")), "production" !== browser$1.env.NODE_ENV && i.some(function (e) {
      return "string" == typeof e && -1 !== e.indexOf("@import");
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), n.styleSheet.server && function (e, n, r, o, s) {
      if (c.isStatic) c.renderStyles(e, b, r, s);else {
        var i = __assign(__assign({}, n), {
          theme: I(n, o, l.defaultProps)
        });
        c.renderStyles(e, i, r, s);
      }
    }(s, e, n.styleSheet, o, n.stylis), null;
  };
  return /*#__PURE__*/React.memo(l);
}
"production" !== browser$1.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");
var wt = "__sc-".concat(f, "__");
"production" !== browser$1.env.NODE_ENV && "test" !== browser$1.env.NODE_ENV && "undefined" != typeof window && (window[wt] || (window[wt] = 0), 1 === window[wt] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window[wt] += 1);
const ErrorBoundaryContext = /*#__PURE__*/React.createContext(null);
const initialState$1 = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState$1;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === undefined ? undefined : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState$1);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === undefined ? undefined : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;

    // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
    // we'd end up resetting the error boundary immediately.
    // This would likely trigger a second error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === undefined ? undefined : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState$1);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = /*#__PURE__*/React.createElement(FallbackComponent, props);
      } else if (fallback === null || /*#__PURE__*/React.isValidElement(fallback)) {
        childToRender = fallback;
      } else {
        throw error;
      }
    }
    return /*#__PURE__*/React.createElement(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}
function assertErrorBoundaryContext(value) {
  if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") {
    throw new Error("ErrorBoundaryContext not found");
  }
}
function useErrorBoundary() {
  const context = React.useContext(ErrorBoundaryContext);
  assertErrorBoundaryContext(context);
  const [state, setState] = React.useState({
    error: null,
    hasError: false
  });
  const memoized = React.useMemo(() => ({
    resetBoundary: () => {
      context.resetErrorBoundary();
      setState({
        error: null,
        hasError: false
      });
    },
    showBoundary: error => setState({
      error,
      hasError: true
    })
  }), [context.resetErrorBoundary]);
  if (state.hasError) {
    throw state.error;
  }
  return memoized;
}
const createStoreImpl = createState => {
  let state;
  const listeners = /* @__PURE__ */new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach(listener => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if ((undefined ? undefined.MODE : undefined) !== "production") {
      console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
    }
    listeners.clear();
  };
  const api = {
    setState,
    getState,
    getInitialState,
    subscribe,
    destroy
  };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = createState => createState ? createStoreImpl(createState) : createStoreImpl;
var withSelector = {
  exports: {}
};
var withSelector_production_min = {};
var shim = {
  exports: {}
};
var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e = React;
  function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var k = "function" === typeof Object.is ? Object.is : h,
    l = e.useState,
    m = e.useEffect,
    n = e.useLayoutEffect,
    p = e.useDebugValue;
  function q(a, b) {
    var d = b(),
      f = l({
        inst: {
          value: d,
          getSnapshot: b
        }
      }),
      c = f[0].inst,
      g = f[1];
    n(function () {
      c.value = d;
      c.getSnapshot = b;
      r(c) && g({
        inst: c
      });
    }, [a, d, b]);
    m(function () {
      r(c) && g({
        inst: c
      });
      return a(function () {
        r(c) && g({
          inst: c
        });
      });
    }, [a]);
    p(d);
    return d;
  }
  function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
      var d = b();
      return !k(a, d);
    } catch (f) {
      return true;
    }
  }
  function t(a, b) {
    return b();
  }
  var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
  useSyncExternalStoreShim_production_min.useSyncExternalStore = undefined !== e.useSyncExternalStore ? e.useSyncExternalStore : u;
  return useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {};
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React$1 = React;
      var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning('error', format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion

          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }
      var objectIs = typeof Object.is === 'function' ? Object.is : is;

      // dispatch for CommonJS interop named imports.

      var useState = React$1.useState,
        useEffect = React$1.useEffect,
        useLayoutEffect = React$1.useLayoutEffect,
        useDebugValue = React$1.useDebugValue;
      var didWarnOld18Alpha = false;
      var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
      // because of a very particular set of implementation details and assumptions
      // -- change any one of them and it will break. The most important assumption
      // is that updates are always synchronous, because concurrent rendering is
      // only available in versions of React that also have a built-in
      // useSyncExternalStore API. And we only use this shim when the built-in API
      // does not exist.
      //
      // Do not assume that the clever hacks used by this hook also work in general.
      // The point of this shim is to replace the need for hacks by other libraries.

      function useSyncExternalStore(subscribe, getSnapshot,
      // Note: The shim does not use getServerSnapshot, because pre-18 versions of
      // React do not expose a way to check if we're hydrating. So users of the shim
      // will need to track that themselves and return the correct value
      // from `getSnapshot`.
      getServerSnapshot) {
        {
          if (!didWarnOld18Alpha) {
            if (React$1.startTransition !== undefined) {
              didWarnOld18Alpha = true;
              error('You are using an outdated, pre-release alpha of React 18 that ' + 'does not support useSyncExternalStore. The ' + 'use-sync-external-store shim will not work correctly. Upgrade ' + 'to a newer pre-release.');
            }
          }
        } // Read the current snapshot from the store on every render. Again, this
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.

        var value = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
              error('The result of getSnapshot should be cached to avoid an infinite loop');
              didWarnUncachedGetSnapshot = true;
            }
          }
        } // Because updates are synchronous, we don't queue them. Instead we force a
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.

        var _useState = useState({
            inst: {
              value: value,
              getSnapshot: getSnapshot
            }
          }),
          inst = _useState[0].inst,
          forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.

        useLayoutEffect(function () {
          inst.value = value;
          inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
          // commit phase if there was an interleaved mutation. In concurrent mode
          // this can happen all the time, but even in synchronous mode, an earlier
          // effect may have mutated the store.

          if (checkIfSnapshotChanged(inst)) {
            // Force a re-render.
            forceUpdate({
              inst: inst
            });
          }
        }, [subscribe, value, getSnapshot]);
        useEffect(function () {
          // Check for changes right before subscribing. Subsequent changes will be
          // detected in the subscription handler.
          if (checkIfSnapshotChanged(inst)) {
            // Force a re-render.
            forceUpdate({
              inst: inst
            });
          }
          var handleStoreChange = function () {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) {
              // Force a re-render.
              forceUpdate({
                inst: inst
              });
            }
          }; // Subscribe to the store and return a clean-up function.

          return subscribe(handleStoreChange);
        }, [subscribe]);
        useDebugValue(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(prevValue, nextValue);
        } catch (error) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        // Note: The shim does not use getServerSnapshot, because pre-18 versions of
        // React do not expose a way to check if we're hydrating. So users of the shim
        // will need to track that themselves and return the correct value
        // from `getSnapshot`.
        return getSnapshot();
      }
      var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
      var isServerEnvironment = !canUseDOM;
      var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
      var useSyncExternalStore$2 = React$1.useSyncExternalStore !== undefined ? React$1.useSyncExternalStore : shim;
      useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim.exports;
  hasRequiredShim = 1;
  if (browser$1.env.NODE_ENV === 'production') {
    shim.exports = requireUseSyncExternalStoreShim_production_min();
  } else {
    shim.exports = requireUseSyncExternalStoreShim_development();
  }
  return shim.exports;
}

/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min) return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h = React,
    n = requireShim();
  function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var q = "function" === typeof Object.is ? Object.is : p,
    r = n.useSyncExternalStore,
    t = h.useRef,
    u = h.useEffect,
    v = h.useMemo,
    w = h.useDebugValue;
  withSelector_production_min.useSyncExternalStoreWithSelector = function (a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
      var f = {
        hasValue: false,
        value: null
      };
      c.current = f;
    } else f = c.current;
    c = v(function () {
      function a(a) {
        if (!c) {
          c = true;
          d = a;
          a = l(a);
          if (undefined !== g && f.hasValue) {
            var b = f.value;
            if (g(b, a)) return k = b;
          }
          return k = a;
        }
        b = k;
        if (q(d, a)) return b;
        var e = l(a);
        if (undefined !== g && g(b, e)) return b;
        d = a;
        return k = e;
      }
      var c = false,
        d,
        k,
        m = undefined === e ? null : e;
      return [function () {
        return a(b());
      }, null === m ? undefined : function () {
        return a(m());
      }];
    }, [b, e, l, g]);
    var d = r(a, c[0], c[1]);
    u(function () {
      f.hasValue = true;
      f.value = d;
    }, [d]);
    w(d);
    return d;
  };
  return withSelector_production_min;
}
var withSelector_development = {};
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  if (hasRequiredWithSelector_development) return withSelector_development;
  hasRequiredWithSelector_development = 1;
  if (browser$1.env.NODE_ENV !== "production") {
    (function () {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React$1 = React;
      var shim = requireShim();

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }
      var objectIs = typeof Object.is === 'function' ? Object.is : is;
      var useSyncExternalStore = shim.useSyncExternalStore;

      // for CommonJS interop.

      var useRef = React$1.useRef,
        useEffect = React$1.useEffect,
        useMemo = React$1.useMemo,
        useDebugValue = React$1.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.

      function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        // Use this to track the rendered snapshot.
        var instRef = useRef(null);
        var inst;
        if (instRef.current === null) {
          inst = {
            hasValue: false,
            value: null
          };
          instRef.current = inst;
        } else {
          inst = instRef.current;
        }
        var _useMemo = useMemo(function () {
            // Track the memoized state using closure variables that are local to this
            // memoized instance of a getSnapshot function. Intentionally not using a
            // useRef hook, because that state would be shared across all concurrent
            // copies of the hook/component.
            var hasMemo = false;
            var memoizedSnapshot;
            var memoizedSelection;
            var memoizedSelector = function (nextSnapshot) {
              if (!hasMemo) {
                // The first time the hook is called, there is no memoized result.
                hasMemo = true;
                memoizedSnapshot = nextSnapshot;
                var _nextSelection = selector(nextSnapshot);
                if (isEqual !== undefined) {
                  // Even if the selector has changed, the currently rendered selection
                  // may be equal to the new selection. We should attempt to reuse the
                  // current value if possible, to preserve downstream memoizations.
                  if (inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, _nextSelection)) {
                      memoizedSelection = currentSelection;
                      return currentSelection;
                    }
                  }
                }
                memoizedSelection = _nextSelection;
                return _nextSelection;
              } // We may be able to reuse the previous invocation's result.

              // We may be able to reuse the previous invocation's result.
              var prevSnapshot = memoizedSnapshot;
              var prevSelection = memoizedSelection;
              if (objectIs(prevSnapshot, nextSnapshot)) {
                // The snapshot is the same as last time. Reuse the previous selection.
                return prevSelection;
              } // The snapshot has changed, so we need to compute a new selection.

              // The snapshot has changed, so we need to compute a new selection.
              var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
              // has changed. If it hasn't, return the previous selection. That signals
              // to React that the selections are conceptually equal, and we can bail
              // out of rendering.

              // If a custom isEqual function is provided, use that to check if the data
              // has changed. If it hasn't, return the previous selection. That signals
              // to React that the selections are conceptually equal, and we can bail
              // out of rendering.
              if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) {
                return prevSelection;
              }
              memoizedSnapshot = nextSnapshot;
              memoizedSelection = nextSelection;
              return nextSelection;
            }; // Assigning this to a constant so that Flow knows it can't change.

            // Assigning this to a constant so that Flow knows it can't change.
            var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;
            var getSnapshotWithSelector = function () {
              return memoizedSelector(getSnapshot());
            };
            var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            };
            return [getSnapshotWithSelector, getServerSnapshotWithSelector];
          }, [getSnapshot, getServerSnapshot, selector, isEqual]),
          getSelection = _useMemo[0],
          getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect(function () {
          inst.hasValue = true;
          inst.value = value;
        }, [value]);
        useDebugValue(value);
        return value;
      }
      withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return withSelector_development;
}
if (browser$1.env.NODE_ENV === 'production') {
  withSelector.exports = requireWithSelector_production_min();
} else {
  withSelector.exports = requireWithSelector_development();
}
var withSelectorExports = withSelector.exports;
var useSyncExternalStoreExports = /*@__PURE__*/getDefaultExportFromCjs(withSelectorExports);
const {
  useDebugValue
} = React;
const {
  useSyncExternalStoreWithSelector
} = useSyncExternalStoreExports;
let didWarnAboutEqualityFn = false;
const identity = arg => arg;
function useStore(api) {
  let selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  let equalityFn = arguments.length > 2 ? arguments[2] : undefined;
  if ((undefined ? undefined.MODE : undefined) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
  useDebugValue(slice);
  return slice;
}
const createImpl = createState => {
  if ((undefined ? undefined.MODE : undefined) !== "production" && typeof createState !== "function") {
    console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = createState => createState ? createImpl(createState) : createImpl;
function createJSONStorage(getStorage, options) {
  let storage;
  try {
    storage = getStorage();
  } catch (_e) {
    return;
  }
  const persistStorage = {
    getItem: name => {
      var _a;
      const parse = str2 => {
        if (str2 === null) {
          return null;
        }
        return JSON.parse(str2, undefined);
      };
      const str = (_a = storage.getItem(name)) != null ? _a : null;
      if (str instanceof Promise) {
        return str.then(parse);
      }
      return parse(str);
    },
    setItem: (name, newValue) => storage.setItem(name, JSON.stringify(newValue, undefined)),
    removeItem: name => storage.removeItem(name)
  };
  return persistStorage;
}
const toThenable = fn => input => {
  try {
    const result = fn(input);
    if (result instanceof Promise) {
      return result;
    }
    return {
      then(onFulfilled) {
        return toThenable(onFulfilled)(result);
      },
      catch(_onRejected) {
        return this;
      }
    };
  } catch (e) {
    return {
      then(_onFulfilled) {
        return this;
      },
      catch(onRejected) {
        return toThenable(onRejected)(e);
      }
    };
  }
};
const oldImpl = (config, baseOptions) => (set, get, api) => {
  let options = {
    getStorage: () => localStorage,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    partialize: state => state,
    version: 0,
    merge: (persistedState, currentState) => ({
      ...currentState,
      ...persistedState
    }),
    ...baseOptions
  };
  let hasHydrated = false;
  const hydrationListeners = /* @__PURE__ */new Set();
  const finishHydrationListeners = /* @__PURE__ */new Set();
  let storage;
  try {
    storage = options.getStorage();
  } catch (_e) {}
  if (!storage) {
    return config(function () {
      console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
      set(...arguments);
    }, get, api);
  }
  const thenableSerialize = toThenable(options.serialize);
  const setItem = () => {
    const state = options.partialize({
      ...get()
    });
    let errorInSync;
    const thenable = thenableSerialize({
      state,
      version: options.version
    }).then(serializedValue => storage.setItem(options.name, serializedValue)).catch(e => {
      errorInSync = e;
    });
    if (errorInSync) {
      throw errorInSync;
    }
    return thenable;
  };
  const savedSetState = api.setState;
  api.setState = (state, replace) => {
    savedSetState(state, replace);
    void setItem();
  };
  const configResult = config(function () {
    set(...arguments);
    void setItem();
  }, get, api);
  let stateFromStorage;
  const hydrate = () => {
    var _a;
    if (!storage) return;
    hasHydrated = false;
    hydrationListeners.forEach(cb => cb(get()));
    const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? undefined : _a.call(options, get())) || undefined;
    return toThenable(storage.getItem.bind(storage))(options.name).then(storageValue => {
      if (storageValue) {
        return options.deserialize(storageValue);
      }
    }).then(deserializedStorageValue => {
      if (deserializedStorageValue) {
        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
          if (options.migrate) {
            return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
          }
          console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
        } else {
          return deserializedStorageValue.state;
        }
      }
    }).then(migratedState => {
      var _a2;
      stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
      set(stateFromStorage, true);
      return setItem();
    }).then(() => {
      postRehydrationCallback == null ? undefined : postRehydrationCallback(stateFromStorage, undefined);
      hasHydrated = true;
      finishHydrationListeners.forEach(cb => cb(stateFromStorage));
    }).catch(e => {
      postRehydrationCallback == null ? undefined : postRehydrationCallback(undefined, e);
    });
  };
  api.persist = {
    setOptions: newOptions => {
      options = {
        ...options,
        ...newOptions
      };
      if (newOptions.getStorage) {
        storage = newOptions.getStorage();
      }
    },
    clearStorage: () => {
      storage == null ? undefined : storage.removeItem(options.name);
    },
    getOptions: () => options,
    rehydrate: () => hydrate(),
    hasHydrated: () => hasHydrated,
    onHydrate: cb => {
      hydrationListeners.add(cb);
      return () => {
        hydrationListeners.delete(cb);
      };
    },
    onFinishHydration: cb => {
      finishHydrationListeners.add(cb);
      return () => {
        finishHydrationListeners.delete(cb);
      };
    }
  };
  hydrate();
  return stateFromStorage || configResult;
};
const newImpl = (config, baseOptions) => (set, get, api) => {
  let options = {
    storage: createJSONStorage(() => localStorage),
    partialize: state => state,
    version: 0,
    merge: (persistedState, currentState) => ({
      ...currentState,
      ...persistedState
    }),
    ...baseOptions
  };
  let hasHydrated = false;
  const hydrationListeners = /* @__PURE__ */new Set();
  const finishHydrationListeners = /* @__PURE__ */new Set();
  let storage = options.storage;
  if (!storage) {
    return config(function () {
      console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
      set(...arguments);
    }, get, api);
  }
  const setItem = () => {
    const state = options.partialize({
      ...get()
    });
    return storage.setItem(options.name, {
      state,
      version: options.version
    });
  };
  const savedSetState = api.setState;
  api.setState = (state, replace) => {
    savedSetState(state, replace);
    void setItem();
  };
  const configResult = config(function () {
    set(...arguments);
    void setItem();
  }, get, api);
  api.getInitialState = () => configResult;
  let stateFromStorage;
  const hydrate = () => {
    var _a, _b;
    if (!storage) return;
    hasHydrated = false;
    hydrationListeners.forEach(cb => {
      var _a2;
      return cb((_a2 = get()) != null ? _a2 : configResult);
    });
    const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? undefined : _b.call(options, (_a = get()) != null ? _a : configResult)) || undefined;
    return toThenable(storage.getItem.bind(storage))(options.name).then(deserializedStorageValue => {
      if (deserializedStorageValue) {
        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
          if (options.migrate) {
            return [true, options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)];
          }
          console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
        } else {
          return [false, deserializedStorageValue.state];
        }
      }
      return [false, undefined];
    }).then(migrationResult => {
      var _a2;
      const [migrated, migratedState] = migrationResult;
      stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
      set(stateFromStorage, true);
      if (migrated) {
        return setItem();
      }
    }).then(() => {
      postRehydrationCallback == null ? undefined : postRehydrationCallback(stateFromStorage, undefined);
      stateFromStorage = get();
      hasHydrated = true;
      finishHydrationListeners.forEach(cb => cb(stateFromStorage));
    }).catch(e => {
      postRehydrationCallback == null ? undefined : postRehydrationCallback(undefined, e);
    });
  };
  api.persist = {
    setOptions: newOptions => {
      options = {
        ...options,
        ...newOptions
      };
      if (newOptions.storage) {
        storage = newOptions.storage;
      }
    },
    clearStorage: () => {
      storage == null ? undefined : storage.removeItem(options.name);
    },
    getOptions: () => options,
    rehydrate: () => hydrate(),
    hasHydrated: () => hasHydrated,
    onHydrate: cb => {
      hydrationListeners.add(cb);
      return () => {
        hydrationListeners.delete(cb);
      };
    },
    onFinishHydration: cb => {
      finishHydrationListeners.add(cb);
      return () => {
        finishHydrationListeners.delete(cb);
      };
    }
  };
  if (!options.skipHydration) {
    hydrate();
  }
  return stateFromStorage || configResult;
};
const persistImpl = (config, baseOptions) => {
  if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
    if ((undefined ? undefined.MODE : undefined) !== "production") {
      console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
    }
    return oldImpl(config, baseOptions);
  }
  return newImpl(config, baseOptions);
};
const persist = persistImpl;
const initialState = {
  keytradeLogin: "",
  redirectUrl: "",
  error: [],
  warning: [],
  base64: "",
  state: "",
  code: ""
};
const useSoftkeyStore = create(persist(set => ({
  ...initialState,
  language: "",
  labels: {},
  currentRoute: "",
  env: "",
  setKeytradeLogin: keytradeLogin => set({
    keytradeLogin
  }),
  setLanguage: language => set({
    language
  }),
  setRedirectUrl: redirectUrl => set({
    redirectUrl
  }),
  setError: error => set({
    error
  }),
  setWarning: warning => set({
    warning
  }),
  setBase64: base64 => set({
    base64
  }),
  setState: state => set({
    state
  }),
  setCode: code => set({
    code
  }),
  setLabels: labels => set({
    labels
  }),
  setCurrentRoute: currentRoute => set({
    currentRoute
  }),
  setEnv: env => set({
    env
  }),
  resetState: () => set(initialState)
}), {
  name: 'softkey-store'
}));
const ROUTES = {
  HOME: 'home',
  COMPLETE: 'complete',
  NOT_FOUND: 'not_found',
  END: 'end',
  SUCCESS: 'success'
};
const CenterContent = dt.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 32px;
`;
const LinkWrapper = dt.div`
  margin: 60px auto 0;
`;
dt(componentsLink.Link)`
    font-size: inherit !important; 
`;
const NotFound = () => {
  const softkeyStore = useSoftkeyStore();
  React.useEffect(() => {
    if (softkeyStore.keytradeLogin !== '') {
      softkeyStore.resetState();
    }
  }, []);
  const labels = softkeyStore.labels['404'];
  return /*#__PURE__*/React.createElement(CenterContent, null, /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "img_fileLost",
    size: "22rem",
    margin: "32px auto 0"
  }), /*#__PURE__*/React.createElement(componentsTitle.Title, {
    level: "h2",
    size: "xxxl",
    center: true
  }, labels.title), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    style: {
      fontSize: '1.8rem'
    },
    margin: "24px 0 0"
  }, labels.subtitle), /*#__PURE__*/React.createElement(componentsList.List, {
    margin: 16
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.reason_one), /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.reason_two), /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.reason_three))), /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(componentsButton.Button, {
    size: "lg",
    onClick: () => {
      if (typeof window !== 'undefined') {
        window.history.replaceState(null, '', window.location.pathname);
      }
      softkeyStore.setCurrentRoute(ROUTES.HOME);
    }
  }, labels.button_label)));
};
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }
  var _proto = Subscribable.prototype;
  _proto.subscribe = function subscribe(listener) {
    var _this = this;
    var callback = listener || function () {
      return undefined;
    };
    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });
      _this.onUnsubscribe();
    };
  };
  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };
  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };
  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };
  return Subscribable;
}();
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }
  if (typeof arg2 === 'function') {
    return _extends$1({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }
  return _extends$1({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    return _extends$1({}, arg2, {
      mutationKey: arg1
    });
  }
  if (typeof arg1 === 'function') {
    return _extends$1({}, arg2, {
      mutationFn: arg1
    });
  }
  return _extends$1({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [_extends$1({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
    exact = filters.exact,
    fetching = filters.fetching,
    inactive = filters.inactive,
    predicate = filters.predicate,
    queryKey = filters.queryKey,
    stale = filters.stale;
  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }
  var queryStatusFilter = mapQueryStatusFilter(active, inactive);
  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();
    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }
    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }
  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }
  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }
  if (predicate && !predicate(query)) {
    return false;
  }
  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
    fetching = filters.fetching,
    predicate = filters.predicate,
    mutationKey = filters.mutationKey;
  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }
    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }
  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }
  if (predicate && !predicate(mutation)) {
    return false;
  }
  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? undefined : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }
  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }
  var array = Array.isArray(a) && Array.isArray(b);
  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;
    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);
      if (copy[key] === a[key]) {
        equalItems++;
      }
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
  }
  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }
  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor

  var ctor = o.constructor;
  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype

  var prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method

  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object

  return true;
}
function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}
function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}
var FocusManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(FocusManager, _Subscribable);
  function FocusManager() {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.setup = function (onFocus) {
      var _window;
      if (!isServer && ((_window = window) == null ? undefined : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus

        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };
    return _this;
  }
  var _proto = FocusManager.prototype;
  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null ? undefined : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };
  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
      _this2 = this;
    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? undefined : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };
  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;
    if (focused) {
      this.onFocus();
    }
  };
  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };
  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native

    if (typeof document === 'undefined') {
      return true;
    }
    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };
  return FocusManager;
}(Subscribable);
var focusManager = new FocusManager();
var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(OnlineManager, _Subscribable);
  function OnlineManager() {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.setup = function (onOnline) {
      var _window;
      if (!isServer && ((_window = window) == null ? undefined : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online

        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };
    return _this;
  }
  var _proto = OnlineManager.prototype;
  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null ? undefined : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };
  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
      _this2 = this;
    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? undefined : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };
  _proto.setOnline = function setOnline(online) {
    this.online = online;
    if (online) {
      this.onOnline();
    }
  };
  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };
  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }
    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }
    return navigator.onLine;
  };
  return OnlineManager;
}(Subscribable);
var onlineManager = new OnlineManager();
function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function isCancelable(value) {
  return typeof (value == null ? undefined : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? undefined : options.revert;
  this.silent = options == null ? undefined : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;
  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;
  this.cancel = function (cancelOptions) {
    return cancelFn == null ? undefined : cancelFn(cancelOptions);
  };
  this.cancelRetry = function () {
    cancelRetry = true;
  };
  this.continueRetry = function () {
    cancelRetry = false;
  };
  this.continue = function () {
    return continueFn == null ? undefined : continueFn();
  };
  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });
  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? undefined : config.onSuccess(value);
      continueFn == null ? undefined : continueFn();
      promiseResolve(value);
    }
  };
  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? undefined : config.onError(value);
      continueFn == null ? undefined : continueFn();
      promiseReject(value);
    }
  };
  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? undefined : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? undefined : config.onContinue();
    });
  }; // Create loop function

  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }
    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch

    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? undefined : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation

    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?

      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }
      _this.failureCount++; // Notify on fail

      config.onFail == null ? undefined : config.onFail(_this.failureCount, error); // Delay

      sleep(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!focusManager.isFocused() || !onlineManager.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop

  run();
};

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;
    this.notifyFn = function (callback) {
      callback();
    };
    this.batchNotifyFn = function (callback) {
      callback();
    };
  }
  var _proto = NotifyManager.prototype;
  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;
    try {
      result = callback();
    } finally {
      this.transactions--;
      if (!this.transactions) {
        this.flush();
      }
    }
    return result;
  };
  _proto.schedule = function schedule(callback) {
    var _this = this;
    if (this.transactions) {
      this.queue.push(callback);
    } else {
      scheduleMicrotask(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */;
  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2.schedule(function () {
        callback.apply(undefined, args);
      });
    };
  };
  _proto.flush = function flush() {
    var _this3 = this;
    var queue = this.queue;
    this.queue = [];
    if (queue.length) {
      scheduleMicrotask(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */;
  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */;
  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };
  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

// TYPES
// FUNCTIONS
var logger$1 = console;
function getLogger() {
  return logger$1;
}
function setLogger(newLogger) {
  logger$1 = newLogger;
}

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }
  var _proto = Query.prototype;
  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;
    this.options = _extends$1({}, this.defaultOptions, options);
    this.meta = options == null ? undefined : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };
  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };
  _proto.scheduleGc = function scheduleGc() {
    var _this = this;
    this.clearGcTimeout();
    if (isValidTimeout(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };
  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };
  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };
  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;
    var prevData = this.state.data; // Get the new data

    var data = functionalUpdate(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? undefined : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = replaceEqualDeep(prevData, data);
    } // Set data and mark it as cached

    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? undefined : options.updatedAt
    });
    return data;
  };
  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };
  _proto.cancel = function cancel(options) {
    var _this$retryer;
    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? undefined : _this$retryer.cancel(options);
    return promise ? promise.then(noop).catch(noop) : Promise.resolve();
  };
  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };
  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };
  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };
  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };
  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };
  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === undefined) {
      staleTime = 0;
    }
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  };
  _proto.onFocus = function onFocus() {
    var _this$retryer2;
    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });
    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused

    (_this$retryer2 = this.retryer) == null ? undefined : _this$retryer2.continue();
  };
  _proto.onOnline = function onOnline() {
    var _this$retryer3;
    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });
    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused

    (_this$retryer3 = this.retryer) == null ? undefined : _this$retryer3.continue();
  };
  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };
  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });
      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }
        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }
      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };
  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };
  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };
  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
      _this$options$behavio,
      _context$fetchOptions,
      _abortController$abor;
    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? undefined : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? undefined : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used

    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.

    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });
      if (observer) {
        this.setOptions(observer.options);
      }
    }
    var queryKey = ensureQueryKeyArray(this.queryKey);
    var abortController = getAbortController(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }
        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }
      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook

    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };
    if ((_this$options$behavio = this.options.behavior) == null ? undefined : _this$options$behavio.onFetch) {
      var _this$options$behavio2;
      (_this$options$behavio2 = this.options.behavior) == null ? undefined : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? undefined : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;
      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? undefined : _context$fetchOptions2.meta
      });
    } // Try to fetch the data

    this.retryer = new Retryer({
      fn: context.fetchFn,
      abort: abortController == null ? undefined : (_abortController$abor = abortController.abort) == null ? undefined : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback

        _this2.cache.config.onSuccess == null ? undefined : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!(isCancelledError(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }
        if (!isCancelledError(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? undefined : _this2.cache.config.onError(error, _this2); // Log error

          getLogger().error(error);
        } // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };
  _proto.dispatch = function dispatch(action) {
    var _this3 = this;
    this.state = this.reducer(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });
      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };
  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };
  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;
    switch (action.type) {
      case 'failed':
        return _extends$1({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });
      case 'pause':
        return _extends$1({}, state, {
          isPaused: true
        });
      case 'continue':
        return _extends$1({}, state, {
          isPaused: false
        });
      case 'fetch':
        return _extends$1({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });
      case 'success':
        return _extends$1({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });
      case 'error':
        var error = action.error;
        if (isCancelledError(error) && error.revert && this.revertState) {
          return _extends$1({}, this.revertState);
        }
        return _extends$1({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });
      case 'invalidate':
        return _extends$1({}, state, {
          isInvalidated: true
        });
      case 'setState':
        return _extends$1({}, state, action.state);
      default:
        return state;
    }
  };
  return Query;
}();

// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(QueryCache, _Subscribable);
  function QueryCache(config) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }
  var _proto = QueryCache.prototype;
  _proto.build = function build(client, options, state) {
    var _options$queryHash;
    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
    var query = this.get(queryHash);
    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }
    return query;
  };
  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };
  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];
    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });
      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }
      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };
  _proto.clear = function clear() {
    var _this2 = this;
    notifyManager.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };
  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };
  _proto.getAll = function getAll() {
    return this.queries;
  };
  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
      filters = _parseFilterArgs[0];
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }
    return this.queries.find(function (query) {
      return matchQuery(filters, query);
    });
  };
  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
      filters = _parseFilterArgs2[0];
    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return matchQuery(filters, query);
    }) : this.queries;
  };
  _proto.notify = function notify(event) {
    var _this3 = this;
    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };
  _proto.onFocus = function onFocus() {
    var _this4 = this;
    notifyManager.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };
  _proto.onOnline = function onOnline() {
    var _this5 = this;
    notifyManager.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };
  return QueryCache;
}(Subscribable);

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = _extends$1({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }
  var _proto = Mutation.prototype;
  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };
  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };
  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };
  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(noop).catch(noop);
    }
    return Promise.resolve();
  };
  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }
    return this.execute();
  };
  _proto.execute = function execute() {
    var _this = this;
    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();
    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? undefined : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? undefined : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }
    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? undefined : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? undefined : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? undefined : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });
      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? undefined : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      getLogger().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? undefined : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? undefined : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });
        throw error;
      });
    });
  };
  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
      _this$options$retry;
    this.retryer = new Retryer({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }
        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };
  _proto.dispatch = function dispatch(action) {
    var _this3 = this;
    this.state = reducer(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });
      _this3.mutationCache.notify(_this3);
    });
  };
  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}
function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return _extends$1({}, state, {
        failureCount: state.failureCount + 1
      });
    case 'pause':
      return _extends$1({}, state, {
        isPaused: true
      });
    case 'continue':
      return _extends$1({}, state, {
        isPaused: false
      });
    case 'loading':
      return _extends$1({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });
    case 'success':
      return _extends$1({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });
    case 'error':
      return _extends$1({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });
    case 'setState':
      return _extends$1({}, state, action.state);
    default:
      return state;
  }
}

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(MutationCache, _Subscribable);
  function MutationCache(config) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }
  var _proto = MutationCache.prototype;
  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };
  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };
  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };
  _proto.clear = function clear() {
    var _this2 = this;
    notifyManager.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };
  _proto.getAll = function getAll() {
    return this.mutations;
  };
  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }
    return this.mutations.find(function (mutation) {
      return matchMutation(filters, mutation);
    });
  };
  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return matchMutation(filters, mutation);
    });
  };
  _proto.notify = function notify(mutation) {
    var _this3 = this;
    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };
  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };
  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };
  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(noop);
        });
      }, Promise.resolve());
    });
  };
  return MutationCache;
}(Subscribable);
function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? undefined : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? undefined : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? undefined : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? undefined : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? undefined : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? undefined : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? undefined : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? undefined : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? undefined : _context$state$data2.pageParams) || [];
        var abortController = getAbortController();
        var abortSignal = abortController == null ? undefined : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };
        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page

        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }
          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }
          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });
          if (isCancelable(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }
          return promise;
        };
        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          var manual = typeof pageParam !== 'undefined';
          var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          var _manual = typeof pageParam !== 'undefined';
          var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, _manual, _param, true);
        } // Refetch pages
        else {
          (function () {
            newPageParams = [];
            var manual = typeof context.options.getNextPageParam === 'undefined';
            var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

            promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

            var _loop = function _loop(i) {
              promise = promise.then(function (pages) {
                var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                if (shouldFetchNextPage) {
                  var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                  return fetchPage(pages, manual, _param2);
                }
                return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
              });
            };
            for (var i = 1; i < oldPages.length; i++) {
              _loop(i);
            }
          })();
        }
        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;
        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? undefined : abortController.abort();
          if (isCancelable(promise)) {
            promise.cancel();
          }
        };
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? undefined : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? undefined : options.getPreviousPageParam(pages[0], pages);
}

// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === undefined) {
      config = {};
    }
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }
  var _proto = QueryClient.prototype;
  _proto.mount = function mount() {
    var _this = this;
    this.unsubscribeFocus = focusManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onFocus();
        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onOnline();
        _this.queryCache.onOnline();
      }
    });
  };
  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;
    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? undefined : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? undefined : _this$unsubscribeOnli.call(this);
  };
  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
      filters = _parseFilterArgs[0];
    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };
  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll(_extends$1({}, filters, {
      fetching: true
    })).length;
  };
  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;
    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? undefined : _this$queryCache$find.state.data;
  };
  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
        state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };
  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = parseQueryArgs(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };
  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;
    return notifyManager.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };
  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;
    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? undefined : _this$queryCache$find2.state;
  };
  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
      filters = _parseFilterArgs2[0];
    var queryCache = this.queryCache;
    notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };
  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;
    var _parseFilterArgs3 = parseFilterArgs(arg1, arg2, arg3),
      filters = _parseFilterArgs3[0],
      options = _parseFilterArgs3[1];
    var queryCache = this.queryCache;
    var refetchFilters = _extends$1({}, filters, {
      active: true
    });
    return notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };
  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;
    var _parseFilterArgs4 = parseFilterArgs(arg1, arg2, arg3),
      filters = _parseFilterArgs4[0],
      _parseFilterArgs4$ = _parseFilterArgs4[1],
      cancelOptions = _parseFilterArgs4$ === undefined ? {} : _parseFilterArgs4$;
    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }
    var promises = notifyManager.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(noop).catch(noop);
  };
  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
      _filters$refetchActiv,
      _filters$refetchInact,
      _this5 = this;
    var _parseFilterArgs5 = parseFilterArgs(arg1, arg2, arg3),
      filters = _parseFilterArgs5[0],
      options = _parseFilterArgs5[1];
    var refetchFilters = _extends$1({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });
    return notifyManager.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });
      return _this5.refetchQueries(refetchFilters, options);
    });
  };
  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;
    var _parseFilterArgs6 = parseFilterArgs(arg1, arg2, arg3),
      filters = _parseFilterArgs6[0],
      options = _parseFilterArgs6[1];
    var promises = notifyManager.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, _extends$1({}, options, {
          meta: {
            refetchPage: filters == null ? undefined : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(noop);
    if (!(options == null ? undefined : options.throwOnError)) {
      promise = promise.catch(noop);
    }
    return promise;
  };
  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }
    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };
  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(noop).catch(noop);
  };
  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };
  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(noop).catch(noop);
  };
  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;
    var promises = notifyManager.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(noop).catch(noop);
  };
  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };
  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };
  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };
  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };
  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };
  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };
  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return hashQueryKey(queryKey) === hashQueryKey(x.queryKey);
    });
    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };
  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;
    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return partialMatchKey(queryKey, x.queryKey);
    })) == null ? undefined : _this$queryDefaults$f.defaultOptions : undefined;
  };
  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return hashQueryKey(mutationKey) === hashQueryKey(x.mutationKey);
    });
    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };
  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;
    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return partialMatchKey(mutationKey, x.mutationKey);
    })) == null ? undefined : _this$mutationDefault.defaultOptions : undefined;
  };
  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? undefined : options._defaulted) {
      return options;
    }
    var defaultedOptions = _extends$1({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? undefined : options.queryKey), options, {
      _defaulted: true
    });
    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
    }
    return defaultedOptions;
  };
  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };
  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? undefined : options._defaulted) {
      return options;
    }
    return _extends$1({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? undefined : options.mutationKey), options, {
      _defaulted: true
    });
  };
  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };
  return QueryClient;
}();
var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(QueryObserver, _Subscribable);
  function QueryObserver(client, options) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;
    _this.bindMethods();
    _this.setOptions(options);
    return _this;
  }
  var _proto = QueryObserver.prototype;
  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };
  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);
      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }
      this.updateTimers();
    }
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };
  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };
  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };
  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };
  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);
    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one

    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }
    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result

    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }
    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };
  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };
  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };
  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;
    var trackedResult = {};
    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };
    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });
    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }
    return trackedResult;
  };
  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;
    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();
          if (result.isError && (options == null ? undefined : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };
  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };
  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };
  _proto.refetch = function refetch(options) {
    return this.fetch(_extends$1({}, options, {
      meta: {
        refetchPage: options == null ? undefined : options.refetchPage
      }
    }));
  };
  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };
  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;
    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();
      return _this5.currentResult;
    });
  };
  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? undefined : fetchOptions.throwOnError)) {
      promise = promise.catch(noop);
    }
    return promise;
  };
  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;
    this.clearStaleTimeout();
    if (isServer || this.currentResult.isStale || !isValidTimeout(this.options.staleTime)) {
      return;
    }
    var time = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };
  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;
    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };
  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;
    if (isServer || this.options.enabled === false || !isValidTimeout(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }
    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };
  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };
  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };
  _proto.clearStaleTimeout = function clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  };
  _proto.clearRefetchInterval = function clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  };
  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
      error = state.error,
      errorUpdatedAt = state.errorUpdatedAt,
      isFetching = state.isFetching,
      status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
      if (fetchOnMount || fetchOptionally) {
        isFetching = true;
        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed

    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? undefined : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? undefined : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          if (options.structuralSharing !== false) {
            data = replaceEqualDeep(prevResult == null ? void 0 : prevResult.data, data);
          }
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          getLogger().error(selectError);
          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed

    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? undefined : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? undefined : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            if (options.structuralSharing !== false) {
              placeholderData = replaceEqualDeep(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }
            this.selectError = null;
          } catch (selectError) {
            getLogger().error(selectError);
            this.selectError = selectError;
          }
        }
      }
      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }
    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }
    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };
  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }
    var _this$options = this.options,
      notifyOnChangeProps = _this$options.notifyOnChangeProps,
      notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }
    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }
    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? undefined : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? undefined : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };
  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if (shallowEqualObjects(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger

    var defaultNotifyOptions = {
      cache: true
    };
    if ((notifyOptions == null ? undefined : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }
    this.notify(_extends$1({}, defaultNotifyOptions, notifyOptions));
  };
  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);
    if (query === this.currentQuery) {
      return;
    }
    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;
    if (this.hasListeners()) {
      prevQuery == null ? undefined : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };
  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};
    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !isCancelledError(action.error)) {
      notifyOptions.onError = true;
    }
    this.updateResult(notifyOptions);
    if (this.hasListeners()) {
      this.updateTimers();
    }
  };
  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;
    notifyManager.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? undefined : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? undefined : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? undefined : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? undefined : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners

      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners

      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };
  return QueryObserver;
}(Subscribable);
function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }
  return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}
function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}

// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(MutationObserver, _Subscribable);
  function MutationObserver(client, options) {
    var _this;
    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.setOptions(options);
    _this.bindMethods();
    _this.updateResult();
    return _this;
  }
  var _proto = MutationObserver.prototype;
  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };
  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };
  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;
      (_this$currentMutation = this.currentMutation) == null ? undefined : _this$currentMutation.removeObserver(this);
    }
  };
  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };
    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }
    this.notify(notifyOptions);
  };
  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };
  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };
  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;
    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }
    this.currentMutation = this.client.getMutationCache().build(this.client, _extends$1({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };
  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : getDefaultState();
    var result = _extends$1({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });
    this.currentResult = result;
  };
  _proto.notify = function notify(options) {
    var _this2 = this;
    notifyManager.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? undefined : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? undefined : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? undefined : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? undefined : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners

      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };
  return MutationObserver;
}(Subscribable);
var unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;
notifyManager.setBatchNotifyFunction(unstable_batchedUpdates);
var logger = console;
setLogger(logger);
var defaultContext = /*#__PURE__*/React.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/React.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }
    return window.ReactQueryClientContext;
  }
  return defaultContext;
}
var useQueryClient = function useQueryClient() {
  var queryClient = React.useContext(getQueryClientContext(React.useContext(QueryClientSharingContext)));
  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }
  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
    _ref$contextSharing = _ref.contextSharing,
    contextSharing = _ref$contextSharing === undefined ? false : _ref$contextSharing,
    children = _ref.children;
  React.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/React.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/React.createElement(Context.Provider, {
    value: client
  }, children));
};
function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}
var QueryErrorResetBoundaryContext = /*#__PURE__*/React.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return React.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(undefined, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior

  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
function useMutation(arg1, arg2, arg3) {
  var mountedRef = React.useRef(false);
  var _React$useState = React.useState(0),
    forceUpdate = _React$useState[1];
  var options = parseMutationArgs(arg1, arg2);
  var queryClient = useQueryClient();
  var obsRef = React.useRef();
  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }
  var currentResult = obsRef.current.getCurrentResult();
  React.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = React.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(noop);
  }, []);
  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }
  return _extends$1({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
function useBaseQuery(options, Observer) {
  var mountedRef = React.useRef(false);
  var _React$useState = React.useState(0),
    forceUpdate = _React$useState[1];
  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager.batchCalls(defaultedOptions.onError);
  }
  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager.batchCalls(defaultedOptions.onSuccess);
  }
  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager.batchCalls(defaultedOptions.onSettled);
  }
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches

    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }
  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }
  var _React$useState2 = React.useState(function () {
      return new Observer(queryClient, defaultedOptions);
    }),
    observer = _React$useState2[0];
  var result = observer.getOptimisticResult(defaultedOptions);
  React.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  React.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? undefined : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? undefined : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? undefined : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? undefined : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary

  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking

  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }
  return result;
}
function useQuery(arg1, arg2, arg3) {
  var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
const queryConfig = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    retry: false
  }
};
const queryClient = new QueryClient({
  defaultOptions: queryConfig
});
const AppProvider = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: NotFound
  }, children));
};
const MinWidthDiv = dt.div`
    min-width: 300px;
`;
const StyledCard = props => {
  return /*#__PURE__*/React.createElement(componentsCard.Card, {
    fillContainer: true
  }, props.children);
};
const SpaceOnTop$1 = dt.div`
    padding-top: 2rem;
`;
const ContinueButton = props => {
  return /*#__PURE__*/React.createElement(SpaceOnTop$1, null, /*#__PURE__*/React.createElement(componentsButton.Button, props, props.children));
};
const SpaceOnTop = dt.div`
    margin-top: 2rem;
`;
const StyledInputText = props => {
  return /*#__PURE__*/React.createElement(SpaceOnTop, null, /*#__PURE__*/React.createElement(componentsInputtext.InputText, {
    label: props.label,
    placeholder: props.placeholder,
    onChange: props.onChange,
    value: props.value,
    error: props.error
  }));
};
const CenteredTextDiv = dt.div`
    text-align: center;
`;
dt(componentsParagraph.Paragraph)`
    padding-top: 4rem;
`;
dt.div`
    text-align:center;
`;
const StyledParagraphLightGrey = props => {
  return /*#__PURE__*/React.createElement(CenteredTextDiv, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    size: "sm",
    color: "GreyBlue"
  }, props.children));
};
const StyledTitle = props => {
  return /*#__PURE__*/React.createElement(componentsTitle.Title, {
    level: "h2",
    size: "sm",
    center: true,
    margin: "2rem"
  }, props.children);
};
const StyledSubTitle = props => {
  return /*#__PURE__*/React.createElement(componentsTitle.Title, {
    level: "h2",
    size: "xs",
    margin: "2rem"
  }, props.children);
};
const API_URL_TEST = "https://www.test.w.keytradebank.be/node/backend/cldprxy/s/access-mgmt";
const API_URL_PROD = "https://www.keytradebank.be/node/backend/cldprxy/s/access-mgmt";
const API_URL_UAT = "https://www.uat.w.keytradebank.be/node/backend/cldprxy/s/access-mgmt";
const API_URL_SIT = "https://www.sit.w.keytradebank.be/node/backend/cldprxy/s/access-mgmt";
const fetchFromAccessMgmt = async function (path, options) {
  let env = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "test";
  let url = getBaseUrl();
  const response = await fetch(`${url}${path}`, options);
  if (response.ok) {
    return response.json();
  }
  throw new Error(response.statusText);
};
const getBaseUrl = env => {
  if (typeof window !== 'undefined') {
    switch (window.location.host) {
      case 'www.uat.w.keytradebank.be':
        return API_URL_UAT;
      case 'www.sit.w.keytradebank.be':
        return API_URL_SIT;
      case 'www.test.w.keytradebank.be':
        return API_URL_TEST;
      default:
        return API_URL_PROD;
    }
  } else {
    switch (env) {
      case "sit":
        return API_URL_SIT;
      case "test":
        return API_URL_TEST;
      case "uat":
        return API_URL_UAT;
      default:
        return API_URL_PROD;
    }
  }
};
const startSoftkeyRecovery = async _ref5 => {
  let {
    KEYT,
    language,
    env
  } = _ref5;
  const response = await fetchFromAccessMgmt(`/activation/start`, {
    method: "POST",
    body: JSON.stringify({
      keytrade_login: KEYT,
      language
    }),
    headers: {
      "Content-Type": "application/json"
    }
  }, env);
  if (response) {
    return response;
  }
  throw new Error();
};
const useStartSoftkeyRecovery = _ref6 => {
  let {
    config
  } = _ref6;
  const softkeyStore = useSoftkeyStore();
  return useMutation({
    onError: error => {
      softkeyStore.setError(error);
    },
    onSuccess: data => {
      if (data.success) {
        softkeyStore.setRedirectUrl(data.redirect_url);
      } else {
        softkeyStore.setError(data.error[0]);
      }
      // softkeyStore.setRedirectUrl("/activation/complete");
    },
    ...config,
    mutationFn: startSoftkeyRecovery
  });
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const PaddedLink = dt(componentsLink.Link)`
    padding: 1rem;
`;
const PaddedNoLink = dt(componentsLink.Link)`
    padding: 1rem;
    cursor:default;
    text-align: center;
    button {
        text-align: center;
        text-weight:700;
    }
`;
const StyledLinkWithArrow = props => {
  return /*#__PURE__*/React.createElement(PaddedLink, _extends({}, props, {
    iconRight: /*#__PURE__*/React.createElement(componentsIcon.Icon, {
      icon: "icn_longArrowRight",
      color: "#5A7A8E",
      style: {
        fill: '#5A7A8E'
      }
    })
  }), props.children);
};
const StyledLinkWarning = props => {
  return /*#__PURE__*/React.createElement(PaddedNoLink, _extends({}, props, {
    size: "lg",
    weight: "bold",
    iconLeft: /*#__PURE__*/React.createElement(componentsIcon.Icon, {
      icon: "icn_exclamationCircle",
      color: "#DE9617",
      style: {
        fill: '#DE9617'
      }
    })
  }), props.children);
};
const CenteredColumnDiv = dt.div`
    display: flex;
    flex-direction: column;
`;
const Home = () => {
  const softkeyStore = useSoftkeyStore();
  React.useEffect(() => {
    if (softkeyStore.keytradeLogin !== '') {
      softkeyStore.resetState();
    }
  }, []);
  const labels = softkeyStore.labels['home_screen'];
  const startSoftkeyRecoveryMutation = useStartSoftkeyRecovery(softkeyStore.keytradeLogin);
  const {
    showBoundary
  } = useErrorBoundary();
  const onSuccess = () => {
    softkeyStore.setCurrentRoute(ROUTES.END);
  };
  const onError = () => {
    showBoundary();
  };
  const handleNextStep = async () => {
    try {
      const result = await startSoftkeyRecoveryMutation.mutateAsync({
        KEYT: softkeyStore.keytradeLogin,
        language: softkeyStore.language,
        env: softkeyStore.env
      });
      if (result.success) {
        onSuccess();
      }
    } catch (e) {
      onError();
    }
  };
  return /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "2rem"
    }
  }, /*#__PURE__*/React.createElement(StyledTitle, null, " ", labels.title, " "), /*#__PURE__*/React.createElement(StyledParagraphLightGrey, null, " ", labels.subtitle, " "), /*#__PURE__*/React.createElement(StyledInputText, {
    label: labels.username_label,
    labelWeight: "semiBold",
    placeholder: labels.username_placeholder,
    value: softkeyStore.keytradeLogin,
    onChange: e => softkeyStore.setKeytradeLogin(e.target.value)
  }), /*#__PURE__*/React.createElement(ContinueButton, {
    fullWidth: true,
    onClick: handleNextStep
  }, labels.continue))), /*#__PURE__*/React.createElement(StyledLinkWithArrow, {
    iconRight: "icn_arrowRight",
    href: labels.link_manual_activation_href,
    targetBlank: true,
    color: "GreyDark"
  }, labels.link_manual_activation));
};
function AppStore() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "172",
    height: "64",
    viewBox: "0 0 172 64"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    width: "164",
    height: "56",
    x: "0",
    y: "0",
    rx: "8"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "108.5%",
    height: "125%",
    x: "-4.3%",
    y: "-8.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: "2",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: "1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    fillRule: "nonzero",
    d: "M59.333 21c2.497 0 4.026-1.595 4.026-3.894 0-2.31-1.584-3.916-4.059-3.916h-2.332V21h2.365zm-.055-.869h-1.353v-6.072h1.386c1.826 0 3.058 1.265 3.058 3.047 0 1.76-1.188 3.025-3.091 3.025zm7.975.935c1.584 0 2.761-1.111 2.761-2.739s-1.177-2.75-2.761-2.75c-1.661 0-2.772 1.21-2.772 2.75s1.111 2.739 2.772 2.739zm0-.814c-1.111 0-1.859-.858-1.859-1.925 0-1.067.737-1.936 1.859-1.936 1.034 0 1.848.792 1.848 1.936s-.825 1.925-1.848 1.925zm6.215.748l1.232-3.927h.011L75.943 21h.836l1.848-5.357h-.913l-1.342 4.026h-.022l-1.254-4.026h-.77l-1.232 4.026h-.022l-1.353-4.026h-.913L72.654 21h.814zm7.172 0v-2.673c0-1.21.66-1.936 1.672-1.936.781 0 1.32.429 1.32 1.683V21h.891v-3.179c0-1.529-.77-2.244-1.925-2.244-.825 0-1.529.385-1.947 1.034h-.011v-.968h-.891V21h.891zm6.402 0v-8.096h-.891V21h.891zm4.169.066c1.584 0 2.761-1.111 2.761-2.739s-1.177-2.75-2.761-2.75c-1.661 0-2.772 1.21-2.772 2.75s1.111 2.739 2.772 2.739zm0-.814c-1.111 0-1.859-.858-1.859-1.925 0-1.067.737-1.936 1.859-1.936 1.034 0 1.848.792 1.848 1.936s-.825 1.925-1.848 1.925zm6.347.814c.869 0 1.529-.396 1.914-1.034h.011V21h.858v-5.357h-.891v.946l-.022.011c-.385-.649-1.078-1.023-1.87-1.023-1.518 0-2.607 1.199-2.607 2.783 0 1.628 1.133 2.706 2.607 2.706zm.132-.814c-1.1 0-1.837-.814-1.837-1.892 0-1.188.825-1.969 1.837-1.969 1.056 0 1.793.869 1.793 1.969 0 1.133-.803 1.892-1.793 1.892zm6.534.814c.869 0 1.551-.407 1.936-1.056h.011V21h.858v-8.096h-.891V16.6h-.011c-.407-.649-1.1-1.023-1.914-1.023-1.507 0-2.618 1.199-2.618 2.783 0 1.628 1.144 2.706 2.629 2.706zm.121-.814c-1.089 0-1.837-.814-1.837-1.892 0-1.188.825-1.969 1.848-1.969 1.078 0 1.815.869 1.815 1.969 0 1.133-.814 1.892-1.826 1.892zm9.768.814c1.584 0 2.761-1.111 2.761-2.739s-1.177-2.75-2.761-2.75c-1.661 0-2.772 1.21-2.772 2.75s1.111 2.739 2.772 2.739zm0-.814c-1.111 0-1.859-.858-1.859-1.925 0-1.067.737-1.936 1.859-1.936 1.034 0 1.848.792 1.848 1.936s-.825 1.925-1.848 1.925zm4.983.748v-2.673c0-1.21.66-1.936 1.672-1.936.781 0 1.32.429 1.32 1.683V21h.891v-3.179c0-1.529-.77-2.244-1.925-2.244-.825 0-1.529.385-1.947 1.034h-.011v-.968h-.891V21h.891zm9.944.066c.638 0 1.001-.154 1.298-.33l-.231-.781c-.264.143-.594.275-.913.275-.506 0-.649-.308-.649-.957v-2.86h1.771v-.77h-1.771v-1.925l-.891.099v1.826h-.693v.77h.693v2.992c0 1.078.44 1.661 1.386 1.661zm3.355-.066v-2.695c0-1.21.66-1.914 1.727-1.914.781 0 1.32.44 1.32 1.65V21h.891v-3.212c0-1.529-.792-2.211-1.947-2.211-.858 0-1.562.363-1.98 1.001h-.011v-3.674h-.891V21h.891zm7.865.066c1.078 0 1.749-.407 2.211-1.001l-.627-.528c-.33.407-.836.715-1.551.715-1.012 0-1.716-.66-1.837-1.661h4.18c0-.066.022-.22.022-.363 0-1.529-1.001-2.651-2.464-2.651-1.529 0-2.64 1.133-2.64 2.75 0 1.639 1.122 2.739 2.706 2.739zm1.507-3.201h-3.289c.165-.913.847-1.474 1.705-1.474.88 0 1.452.594 1.584 1.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    fillRule: "nonzero",
    d: "M58.533 40.189l.901-2.601h4.93l.918 2.6h2.142l-4.522-12.07h-2.006l-4.505 12.07h2.142zm5.219-4.37h-3.689l1.819-5.235h.034l1.836 5.236zm7.208 7.736v-4.37l.034-.016c.612.748 1.479 1.156 2.601 1.156 2.312 0 4.029-1.683 4.029-4.25 0-2.5-1.717-4.301-4.012-4.301-1.088 0-2.006.39-2.618 1.105h-.034v-.986h-1.904v11.662h1.904zm2.346-4.964c-1.36 0-2.431-1.003-2.431-2.5 0-1.478.986-2.6 2.414-2.6 1.326 0 2.397 1.003 2.397 2.6 0 1.463-.986 2.5-2.38 2.5zm8.211 4.964v-4.37l.034-.016c.612.748 1.479 1.156 2.601 1.156 2.312 0 4.029-1.683 4.029-4.25 0-2.5-1.717-4.301-4.012-4.301-1.088 0-2.006.39-2.618 1.105h-.034v-.986h-1.904v11.662h1.904zm2.346-4.964c-1.36 0-2.431-1.003-2.431-2.5 0-1.478.986-2.6 2.414-2.6 1.326 0 2.397 1.003 2.397 2.6 0 1.463-.986 2.5-2.38 2.5zm14.705 1.734c1.938 0 4.165-1.122 4.165-3.621 0-2.33-1.666-2.89-3.74-3.706-1.462-.561-2.278-.867-2.261-1.751.017-.901.765-1.411 1.7-1.411.816 0 1.785.425 2.771 1.24l1.224-1.614c-1.224-.97-2.567-1.48-3.995-1.48-2.091 0-3.825 1.48-3.825 3.367 0 2.21 1.819 3.026 3.655 3.672 1.53.544 2.329.884 2.329 1.938 0 .884-.68 1.462-2.006 1.462-1.037 0-2.227-.527-3.094-1.581l-1.292 1.58c1.258 1.31 2.822 1.905 4.369 1.905zm8.67 0c1.088 0 1.615-.221 2.108-.493l-.493-1.65c-.442.239-.901.358-1.224.358-.544 0-.799-.306-.799-1.156v-3.876h2.431v-1.615h-2.431v-2.958l-1.904.204v2.754h-1.02v1.615h1.02v4.063c0 1.853.884 2.754 2.312 2.754zm7.599 0c2.55 0 4.352-1.751 4.352-4.267 0-2.55-1.802-4.284-4.352-4.284-2.618 0-4.352 1.836-4.352 4.284 0 2.43 1.734 4.267 4.352 4.267zm0-1.734c-1.428 0-2.414-1.122-2.414-2.533 0-1.445.969-2.567 2.414-2.567 1.36 0 2.414 1.037 2.414 2.567 0 1.496-1.071 2.533-2.414 2.533zm8.245 1.598v-3.927c0-1.36.816-2.397 2.261-2.397.136 0 .357.017.578.034v-2.125h-.238c-1.003 0-1.921.493-2.567 1.36h-.034v-1.241h-1.904v8.296h1.904zm8.228.136c1.785 0 2.822-.663 3.519-1.564l-1.326-1.14c-.425.528-1.105.97-2.091.97-1.292 0-2.193-.714-2.431-1.921h6.052c.017-.136.051-.425.051-.731 0-2.414-1.581-4.165-3.91-4.165-2.431 0-4.165 1.717-4.165 4.267 0 2.6 1.785 4.284 4.301 4.284zm1.853-5.151h-4.148c.272-1.088 1.088-1.683 2.142-1.683 1.088 0 1.768.68 2.006 1.683z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    fillRule: "nonzero",
    d: "M38.308 39.275c-1.25 1.83-2.542 3.647-4.582 3.685-2.008.038-2.651-1.19-4.943-1.19-2.293 0-3.01 1.152-4.906 1.228-1.97.074-3.468-1.975-4.727-3.796-2.573-3.722-4.537-10.525-1.896-15.116 1.308-2.28 3.652-3.722 6.191-3.76 1.935-.036 3.762 1.305 4.943 1.305 1.184 0 3.401-1.61 5.733-1.374.976.04 3.715.394 5.474 2.97-.139.092-3.27 1.916-3.231 5.714.038 4.538 3.972 6.046 4.017 6.067-.035.106-.629 2.153-2.073 4.267zm-8.566-24.003c1.08-1.266 2.904-2.209 4.41-2.272.192 1.76-.515 3.522-1.56 4.791-1.046 1.268-2.759 2.255-4.44 2.123-.228-1.721.619-3.517 1.59-4.642z"
  }))));
}
const Cronto = dt.img`
    width: 250px;
    height: 250px;
    margin-top: 2rem;
    margin-bottom: 2rem;
    margin-left:auto;
    margin-right:auto;
`;
function PlayStore() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "172",
    height: "64",
    viewBox: "0 0 172 64"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    width: "164",
    height: "56",
    x: "0",
    y: "0",
    rx: "8"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "108.5%",
    height: "125%",
    x: "-4.3%",
    y: "-8.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: "2",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: "1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    fillRule: "nonzero",
    d: "M59.333 21c2.497 0 4.026-1.595 4.026-3.894 0-2.31-1.584-3.916-4.059-3.916h-2.332V21h2.365zm-.055-.869h-1.353v-6.072h1.386c1.826 0 3.058 1.265 3.058 3.047 0 1.76-1.188 3.025-3.091 3.025zm7.975.935c1.584 0 2.761-1.111 2.761-2.739s-1.177-2.75-2.761-2.75c-1.661 0-2.772 1.21-2.772 2.75s1.111 2.739 2.772 2.739zm0-.814c-1.111 0-1.859-.858-1.859-1.925 0-1.067.737-1.936 1.859-1.936 1.034 0 1.848.792 1.848 1.936s-.825 1.925-1.848 1.925zm6.215.748l1.232-3.927h.011L75.943 21h.836l1.848-5.357h-.913l-1.342 4.026h-.022l-1.254-4.026h-.77l-1.232 4.026h-.022l-1.353-4.026h-.913L72.654 21h.814zm7.172 0v-2.673c0-1.21.66-1.936 1.672-1.936.781 0 1.32.429 1.32 1.683V21h.891v-3.179c0-1.529-.77-2.244-1.925-2.244-.825 0-1.529.385-1.947 1.034h-.011v-.968h-.891V21h.891zm6.402 0v-8.096h-.891V21h.891zm4.169.066c1.584 0 2.761-1.111 2.761-2.739s-1.177-2.75-2.761-2.75c-1.661 0-2.772 1.21-2.772 2.75s1.111 2.739 2.772 2.739zm0-.814c-1.111 0-1.859-.858-1.859-1.925 0-1.067.737-1.936 1.859-1.936 1.034 0 1.848.792 1.848 1.936s-.825 1.925-1.848 1.925zm6.347.814c.869 0 1.529-.396 1.914-1.034h.011V21h.858v-5.357h-.891v.946l-.022.011c-.385-.649-1.078-1.023-1.87-1.023-1.518 0-2.607 1.199-2.607 2.783 0 1.628 1.133 2.706 2.607 2.706zm.132-.814c-1.1 0-1.837-.814-1.837-1.892 0-1.188.825-1.969 1.837-1.969 1.056 0 1.793.869 1.793 1.969 0 1.133-.803 1.892-1.793 1.892zm6.534.814c.869 0 1.551-.407 1.936-1.056h.011V21h.858v-8.096h-.891V16.6h-.011c-.407-.649-1.1-1.023-1.914-1.023-1.507 0-2.618 1.199-2.618 2.783 0 1.628 1.144 2.706 2.629 2.706zm.121-.814c-1.089 0-1.837-.814-1.837-1.892 0-1.188.825-1.969 1.848-1.969 1.078 0 1.815.869 1.815 1.969 0 1.133-.814 1.892-1.826 1.892zm9.768.814c1.584 0 2.761-1.111 2.761-2.739s-1.177-2.75-2.761-2.75c-1.661 0-2.772 1.21-2.772 2.75s1.111 2.739 2.772 2.739zm0-.814c-1.111 0-1.859-.858-1.859-1.925 0-1.067.737-1.936 1.859-1.936 1.034 0 1.848.792 1.848 1.936s-.825 1.925-1.848 1.925zm4.983.748v-2.673c0-1.21.66-1.936 1.672-1.936.781 0 1.32.429 1.32 1.683V21h.891v-3.179c0-1.529-.77-2.244-1.925-2.244-.825 0-1.529.385-1.947 1.034h-.011v-.968h-.891V21h.891z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M122.894 40.953h1.866V28.452h-1.866v12.501zm16.807-7.998l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.329 7.575-1.898 4.214h1.947l5.13-11.789h-2.075zm-10.582 6.578c-.612 0-1.464-.305-1.464-1.061 0-.965 1.062-1.335 1.978-1.335.821 0 1.206.177 1.705.418a2.262 2.262 0 01-2.219 1.978zm.225-6.851c-1.351 0-2.75.595-3.329 1.914l1.656.691c.354-.691 1.013-.917 1.705-.917.965 0 1.946.579 1.962 1.609v.128c-.338-.193-1.061-.482-1.946-.482-1.785 0-3.603.981-3.603 2.814 0 1.673 1.464 2.751 3.104 2.751 1.255 0 1.946-.563 2.381-1.223h.064v.965h1.801V36.14c0-2.22-1.656-3.458-3.795-3.458zm-11.532 1.795h-2.654v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .969-.792 2.143-2.187 2.143zm-.048-6.025h-4.471v12.501h1.865v-4.736h2.606c2.068 0 4.101-1.498 4.101-3.883s-2.033-3.882-4.101-3.882zM93.383 39.535c-1.289 0-2.368-1.079-2.368-2.561 0-1.498 1.079-2.594 2.368-2.594 1.273 0 2.271 1.096 2.271 2.594 0 1.482-.998 2.561-2.271 2.561zm2.142-5.88h-.064c-.419-.499-1.224-.95-2.239-.95-2.127 0-4.076 1.868-4.076 4.269 0 2.384 1.949 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.967h.064v.612c0 1.628-.869 2.498-2.271 2.498-1.144 0-1.853-.822-2.143-1.515l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.191 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693zm3.062 7.298h1.869V28.451h-1.869v12.502zm4.623-4.124c-.048-1.643 1.273-2.481 2.223-2.481.742 0 1.37.37 1.579.902l-3.802 1.579zm5.8-1.418c-.354-.95-1.434-2.706-3.641-2.706-2.191 0-4.011 1.723-4.011 4.253 0 2.384 1.804 4.253 4.22 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.967c-.483.709-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.288l5.687-2.352-.193-.484zM63.702 34.01v1.804h4.317c-.129 1.015-.467 1.756-.982 2.272-.629.628-1.612 1.32-3.335 1.32-2.658 0-4.737-2.142-4.737-4.8 0-2.659 2.079-4.801 4.737-4.801 1.434 0 2.481.564 3.254 1.289l1.273-1.273C67.149 28.79 65.716 28 63.702 28 60.061 28 57 30.965 57 34.606s3.061 6.605 6.702 6.605c1.965 0 3.447-.644 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.221 0-.419-.032-.805-.097-1.127h-6.073zm11.079 5.525c-1.289 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.401-2.578 1.288 0 2.4 1.047 2.4 2.578 0 1.514-1.112 2.577-2.4 2.577zm0-6.83c-2.353 0-4.27 1.788-4.27 4.253 0 2.448 1.917 4.253 4.27 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.269-4.253zm9.313 6.83c-1.289 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.401-2.578 1.289 0 2.4 1.047 2.4 2.578 0 1.514-1.111 2.577-2.4 2.577zm-4.269-2.577c0 2.448 1.917 4.253 4.269 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.269-4.253-2.352 0-4.269 1.788-4.269 4.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    fillRule: "nonzero",
    d: "M16 40.948V15.055c0-.903.52-1.684 1.277-2.055L32.17 27.997 17.271 43A2.286 2.286 0 0116 40.948zm20.897-8.193L20.61 42.222 33.455 29.29l3.442 3.466zm5.062-6.569c.542.418.891 1.076.891 1.816 0 .728-.339 1.377-.866 1.796l-3.46 2.01-3.785-3.81 3.783-3.81 3.437 1.998zM20.62 13.781l16.274 9.46-3.439 3.464L20.62 13.78z"
  }))));
}
const Separator = dt.div`
    width: 100%;
    height: 1px;
    background-color: #E4E8E1;
    margin-top: 4rem;
    margin-bottom: 4rem;
`;
const completeActivationQrCode = async _ref7 => {
  let {
    state = '',
    code = '',
    env
  } = _ref7;
  try {
    if (state === '' || code === '' || state === null || code === null) {
      return {
        success: false
      };
    }
    const response = await fetchFromAccessMgmt(`/activation/complete`, {
      method: "POST",
      body: JSON.stringify({
        state,
        code
      }),
      headers: {
        "Content-Type": "application/json"
      }
    }, env);
    if (response.success) {
      return response;
    }
    return {
      success: false
    };
  } catch (error) {
    console.log(error);
    return {
      success: false
    };
  }
};
const useCompleteActivationQrCode = _ref8 => {
  let {
    state = '',
    code = '',
    config,
    env
  } = _ref8;
  return useQuery({
    queryKey: ["completeActivationQrCode", state, code],
    queryFn: () => completeActivationQrCode({
      state,
      code,
      env
    }),
    ...config
  });
};
const fetchPollingActivation = async _ref9 => {
  let {
    state,
    env
  } = _ref9;
  const response = await fetchFromAccessMgmt('/activation/pooling/' + state, null, env);
  if (response) {
    return response;
  }
  throw new Error('Error polling activation');
};
const usePolling = _ref0 => {
  let {
    state,
    env
  } = _ref0;
  const [refresh, setRefresh] = React.useState(5000);
  return useQuery({
    queryKey: ['pollingActivation', state],
    queryFn: () => fetchPollingActivation({
      state,
      env
    }),
    refetchInterval: refresh,
    onSuccess: data => {
      if (data === 2) {
        setRefresh(false);
      }
    }
  });
};
const StyledListDiv$1 = dt.div`
background-color: #f1f5f7;
margin-top: -4rem;
margin-bottom: -4rem;
padding-top: 4rem;
padding-bottom: 4rem;
padding-right: 2rem;
li::before {content: counter(li); color: #00B3DB; padding-right: 2rem; padding-left: 2rem;
    display: inline-block; width: 1em;
    margin-left: -1em}
    li {counter-increment: li}
`;
const PillParagraph = dt.div`
    background-color: white;
    color: E4E8E1;
    border-radius: 1rem;
    padding: 0.5rem 1rem;
    margin-left: 1rem;
    font-size: 1.2rem;
    font-weight: 700;
    text-align: center;
`;
const CenteredDiv$2 = dt.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
const FullWidth$2 = dt.div`
    width: 100%;
`;
const StyledParagraph = dt(componentsParagraph.Paragraph)`
    font-size: 1.4rem !important;
`;
const StBBCode = dt(componentsBbcode.BBCode)`
    font-size: 1.4rem !important;
`;
const ONE_MINUTE = 60;
const THIRTY_MINUTES = 30 * ONE_MINUTE;
const Complete = () => {
  let state = "",
    code = "";
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    state = searchParams.get('state');
    code = searchParams.get('code');
  }
  const softkeyStore = useSoftkeyStore();
  const labels = softkeyStore.labels['cronto'];
  const [counter, setCounter] = React.useState(THIRTY_MINUTES);
  React.useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);
  const completeActivationQrCode = useCompleteActivationQrCode({
    code,
    state,
    env: softkeyStore.env
  });
  const polling = usePolling({
    state,
    env: softkeyStore.env
  });
  if (completeActivationQrCode.isSuccess && completeActivationQrCode.data.success === false) {
    if (typeof window !== 'undefined') {
      window.history.replaceState(null, '', window.location.pathname);
    }
    softkeyStore.setCurrentRoute(ROUTES.NOT_FOUND);
  }
  if (polling.isSuccess && [0, 3, 4].includes(polling.data.status)) {
    if (typeof window !== 'undefined') {
      window.history.replaceState(null, '', window.location.pathname);
    }
    softkeyStore.setCurrentRoute(ROUTES.NOT_FOUND);
  }
  if (polling.isSuccess && [2].includes(polling.data.status)) {
    if (typeof window !== 'undefined') {
      window.history.replaceState(null, '', window.location.pathname);
    }
    softkeyStore.setCurrentRoute(ROUTES.SUCCESS);
  }
  return /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(componentsCard.Card, {
    fillContainer: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenteredDiv$2, null, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem',
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      if (typeof window !== 'undefined') {
        window.history.replaceState(null, '', window.location.pathname);
      }
      softkeyStore.setCurrentRoute(ROUTES.END);
    }
  }, /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_arrowLeft"
  })), /*#__PURE__*/React.createElement(FullWidth$2, null, /*#__PURE__*/React.createElement(StyledTitle, null, labels.title)))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(StyledListDiv$1, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(componentsList.List, {
    type: "ordered",
    margin: "2rem"
  }, /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_1)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_2)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      paddingTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: labels.play_store_url
  }, /*#__PURE__*/React.createElement(PlayStore, null)), /*#__PURE__*/React.createElement("a", {
    href: labels.app_store_url
  }, /*#__PURE__*/React.createElement(AppStore, null)))), /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_3)), /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_4)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'contents'
    }
  }, /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_5)), /*#__PURE__*/React.createElement(PillParagraph, null, softkeyStore.keytradeLogin)), /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_6)), /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_7)), /*#__PURE__*/React.createElement(StyledParagraph, null, /*#__PURE__*/React.createElement(StBBCode, null, labels.bullet_8))))), /*#__PURE__*/React.createElement(Separator, null), counter !== 0 && completeActivationQrCode.isSuccess && completeActivationQrCode.data.success && /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(Cronto, {
    src: `data:image/png;base64, ${completeActivationQrCode.data.base64}`
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "200px",
      marginRight: "auto",
      marginLeft: 'auto',
      paddingBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(componentsRangeindicator.RangeIndicator, {
    value: counter,
    valueMax: THIRTY_MINUTES
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      marginRight: "auto",
      marginLeft: 'auto',
      paddingBottom: '4rem',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    weight: "bold"
  }, labels["30_minutes_valid"]))), (counter === 0 || completeActivationQrCode.isSuccess && !completeActivationQrCode.data.success) && /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '250px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(componentsButton.Button, {
    onClick: () => {
      if (typeof window !== 'undefined') {
        window.history.replaceState(null, '', window.location.pathname);
      }
      softkeyStore.setCurrentRoute(ROUTES.HOME);
    }
  }, " ", labels["retry"], " ")))), /*#__PURE__*/React.createElement(StyledLinkWarning, {
    iconLeft: "icn_arrowRight",
    targetBlank: true,
    color: "GreyDark"
  }, labels.disclaimer));
};
var img = "data:image/png;base64,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";
const LinkWithSpaceOnTop = dt.a`
  color: inherit;
  text-decoration: inherit;
  min-width: 350px;
  margin-left:auto;
  margin-right:auto;
`;
const StyledOuterDiv = dt.div`
  border: 1px solid #E4E8E1;
  border-radius: 12px;
  display: flex;
  height: 80px;
`;
const StyledImageDiv = dt.div`
  width: 20%;
  text-align: center;
  align-self: center;
  margin-left: 24px;
`;
const StyledImage = dt.img`
  height: 60px;
`;
const StyledLabelDiv = dt.div`
  font-size: 24px;
  font-weight: bold;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ItsmeButtonStyled = _ref1 => {
  let {
    label
  } = _ref1;
  return /*#__PURE__*/React.createElement(StyledOuterDiv, null, /*#__PURE__*/React.createElement(StyledImageDiv, null, /*#__PURE__*/React.createElement(StyledImage, {
    src: img
  })), /*#__PURE__*/React.createElement(StyledLabelDiv, null, label));
};
const ItsmeButton = _ref10 => {
  let {
    label,
    href
  } = _ref10;
  return /*#__PURE__*/React.createElement(LinkWithSpaceOnTop, {
    href: href
  }, /*#__PURE__*/React.createElement(ItsmeButtonStyled, {
    label: label
  }));
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l = objectAssign;
if ("function" === typeof Symbol && Symbol.for) {
  var w = Symbol.for;
  w("react.element");
  w("react.portal");
  w("react.fragment");
  w("react.strict_mode");
  w("react.profiler");
  w("react.provider");
  w("react.context");
  w("react.forward_ref");
  w("react.suspense");
  w("react.memo");
  w("react.lazy");
}
function z(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = {
    isMounted: function () {
      return false;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  },
  B = {};
function C(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B;
  this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function (a, b) {
  if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
  this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {}
D.prototype = C.prototype;
function E(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B;
  this.updater = c || A;
}
var F = E.prototype = new D();
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = true;
const CenteredDiv$1 = dt.div`
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        cursor: pointer;
    }
`;
const FullWidth$1 = dt.div`
    width: 100%;
`;
const End = () => {
  const softkeyStore = useSoftkeyStore();
  const labels = softkeyStore.labels['redirect_screen'];
  return /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(componentsCard.Card, {
    fillContainer: true
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "2rem"
    }
  }, /*#__PURE__*/React.createElement(CenteredDiv$1, null, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      if (typeof window !== 'undefined') {
        window.history.replaceState(null, '', window.location.pathname);
      }
      softkeyStore.setCurrentRoute(ROUTES.HOME);
    }
  }, /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_arrowLeft"
  })), /*#__PURE__*/React.createElement(FullWidth$1, null, /*#__PURE__*/React.createElement(StyledTitle, null, labels.title))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(CenteredDiv$1, null, /*#__PURE__*/React.createElement(ItsmeButton, {
    label: labels.itsmeBtn,
    href: softkeyStore.redirectUrl
  })), /*#__PURE__*/React.createElement(CenteredDiv$1, null, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, {
    margin: "36px"
  }, labels.subtitle)))), /*#__PURE__*/React.createElement(StyledLinkWithArrow, {
    iconRight: "icn_arrowRight",
    href: labels.no_itsme_href,
    targetBlank: true,
    color: "GreyDark"
  }, labels.no_itsme));
};
const CenteredDiv = dt.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
const FullWidth = dt.div`
    width: 100%;
`;
const StyledListDiv = dt.div`
background-color: #f1f5f7;
margin-top: -4rem;
margin-bottom: -4rem;
padding-top: 4rem;
padding-bottom: 4rem;
padding-right: 2rem;
li::before {content: counter(li); color: #00B3DB; padding-right: 2rem; padding-left: 2rem;
    display: inline-block; width: 1em;
    margin-left: -1em}
    li {counter-increment: li}
`;
const Success = () => {
  const softkeyStore = useSoftkeyStore();
  React.useEffect(() => {
    if (softkeyStore.keytradeLogin !== '') {
      softkeyStore.resetState();
    }
  }, []);
  const labels = softkeyStore.labels['success'];
  return /*#__PURE__*/React.createElement(CenteredColumnDiv, null, /*#__PURE__*/React.createElement(componentsCard.Card, {
    fillContainer: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenteredDiv, null, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem',
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      softkeyStore.setCurrentRoute(ROUTES.COMPLETE);
    }
  }, /*#__PURE__*/React.createElement(componentsIcon.Icon, {
    icon: "icn_arrowLeft"
  })), /*#__PURE__*/React.createElement(FullWidth, null, /*#__PURE__*/React.createElement(StyledTitle, null, labels.title)))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(StyledSubTitle, null, labels.header), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem'
    }
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.subtitle), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: '2rem'
    }
  }, /*#__PURE__*/React.createElement(componentsList.List, {
    type: "iconList"
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.bullet_1)))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(StyledListDiv, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledSubTitle, null, labels.paragraph_1), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem'
    }
  }, /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.paragraph_2), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(componentsParagraph.Paragraph, null, labels.paragraph_3)))), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      marginRight: "auto",
      marginLeft: 'auto',
      paddingBottom: '4rem',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(componentsButton.Button, {
    size: "lg",
    onClick: () => {
      if (typeof window !== 'undefined') {
        window.location.href = `https://www.keytradebank.com/${softkeyStore.language}/`;
      }
    }
  }, labels.button_label)))));
};
const AppRouter = () => {
  const softkeyStore = useSoftkeyStore();
  let elementToRender = /*#__PURE__*/React.createElement(Home, null);
  if (softkeyStore.currentRoute === ROUTES.HOME) {
    elementToRender = /*#__PURE__*/React.createElement(Home, null);
  }
  if (softkeyStore.currentRoute === ROUTES.COMPLETE) {
    elementToRender = /*#__PURE__*/React.createElement(Complete, null);
  }
  if (softkeyStore.currentRoute === ROUTES.END) {
    elementToRender = /*#__PURE__*/React.createElement(End, null);
  }
  if (softkeyStore.currentRoute === ROUTES.SUCCESS) {
    elementToRender = /*#__PURE__*/React.createElement(Success, null);
  }
  if (softkeyStore.currentRoute === ROUTES.NOT_FOUND) {
    elementToRender = /*#__PURE__*/React.createElement(NotFound, null);
  }
  if (typeof window !== 'undefined') {
    if (window.location.search.includes('code') && window.location.search.includes('state')) {
      elementToRender = /*#__PURE__*/React.createElement(Complete, null);
    }
  }
  return /*#__PURE__*/React.createElement(MinWidthDiv, null, elementToRender);
};
const fallbackLabels = {
  "en": {
    "home_screen": {
      "title": "No more access?",
      "subtitle": "We can help you activate a new Softkey with itsme®",
      "username_label": "Keytrade Login",
      "username_placeholder": "ex: KEYTXXXXXX",
      "continue": "Continue",
      "link_manual_activation": "I don't know my keytrade login",
      "link_manual_activation_href": "https://www.keytradebank.be/en/support/request-new-logon-hardkey-or-softkey"
    },
    "redirect_screen": {
      "title": "No more access?",
      "itsmeBtn": "Identify with itsme®",
      "subtitle": "Verify your identity with itsme® to activate a new Softkey on your mobile device",
      "no_itsme": "I don't have itsme®",
      "no_itsme_href": "https://www.itsme-id.com/en-BE/get-started"
    },
    "cronto": {
      "title": "Softkey activation",
      "activate_softkey": "Activate your Softkey",
      "play_store_url": "https://play.google.com/store/apps/details?id=be.keytradebank.phone&hl=en",
      "app_store_url": "https://apps.apple.com/be/app/keytrade-bank/id640974593?l=en",
      "bullet_1": "[b]Take the mobile device[/b] on which you want to authenticate yourself",
      "bullet_2": "Open or Download the app [b]\"Keytrade Bank: Banking & Trading\"[/b]",
      "bullet_3": "On the app, create [b]a profile[/b]",
      "bullet_4": "[b]Choose a name and photo[/b] for your profile",
      "bullet_5": "Enter your [b]username[/b]",
      "bullet_6": "Select [b]\"Softkey\"[/b]",
      "bullet_7": "Create and confirm [b]your PIN[/b]",
      "bullet_8": "[b]Scan the secured QR code[/b] below:",
      "30_minutes_valid": "This QR code will be valid for 30 Minutes",
      "disclaimer": "Attention : make sure nobody scans the QR code with another device!",
      "retry": "Retry"
    },
    "success": {
      "title": "Softkey Activation",
      "header": "Perfect, you just reactivated a new Softkey!",
      "subtitle": "From now on... ",
      "bullet_1": "You can log in with your Softkey and execute your stock market orders and transactions",
      "paragraph_1": "Important to know",
      "paragraph_2": "We recommend that you activate a Softkey on an additional device (smartphone or tablet). You can activate as many as you want.",
      "paragraph_3": "You will always be able to add an extra device via Preferences > Security > Authentication > Request a new Softkey.",
      "button_label": "Log in with your Softkey"
    },
    "404": {
      "title": "Something went wrong",
      "subtitle": "Please try again, ensuring the following points: ",
      "reason_one": "Have entered the correct login (ex: KEYTXXXXXX)",
      "reason_two": "Start the procedure on the same internet connection",
      "reason_three": "Create the profile on the Keytradebank application on the same phone as your itsme.",
      "final_paragraph": "If the problem persists, please contact ",
      "link_title": "contact center.",
      "link": "https://www.keytradebank.be/en/contact",
      "button_label": "Retry"
    }
  },
  "fr": {
    "home_screen": {
      "title": "Accès perdu?",
      "subtitle": "Activez un nouveau Softkey avec itsme®",
      "username_label": "Keytrade Login",
      "username_placeholder": "ex: KEYTXXXXXX",
      "continue": "Continuer",
      "link_manual_activation": "Nom d'utilisateur oublié?",
      "link_manual_activation_href": "https://www.keytradebank.be/fr/aide/request-new-logon-hardkey-or-softkey"
    },
    "redirect_screen": {
      "title": "Accès perdu?",
      "itsmeBtn": "Identifiez avec itsme®",
      "subtitle": "Identifiez avec itsme® pour activer un nouveau Softkey sur votre mobile",
      "no_itsme": "Je n'ai pas itsme®",
      "no_itsme_href": "https://www.itsme-id.com/fr-BE/get-started"
    },
    "cronto": {
      "title": "Activation Softkey",
      "activate_softkey": "Activer votre Softkey",
      "play_store_url": "https://play.google.com/store/apps/details?id=be.keytradebank.phone&hl=fr",
      "app_store_url": "https://apps.apple.com/be/app/keytrade-bank/id640974593?l=fr",
      "bullet_1": "Maintenant, [b]prenez l'appareil mobile[/b] sur lequel vous voulez installer la SoftKey supplémentaire",
      "bullet_2": "Ouvrez ou téléchargez l'app [b]«Keytrade Bank: Banking & Trading»[/b]",
      "bullet_3": "Créez [b]un profil[/b]",
      "bullet_4": "[b]Choisissez un nom et une photo[/b] pour votre profil.",
      "bullet_5": "Entrez votre [b]nom d'utilisateur[/b]",
      "bullet_6": "Séléctionnez [b]«SoftKey»[/b]",
      "bullet_7": "Créez et confirmez votre [b]code PIN[/b]",
      "bullet_8": "[b]Scannez le code QR sécurisé[/b] ci-dessous",
      "30_minutes_valid": "Ce code QR restera disponible pendant 30 minutes",
      "disclaimer": "Attention: veillez à ce que personne ne capture le code QR sécurisé avec un autre smartphone.",
      "retry": "Réessayer"
    },
    "success": {
      "title": "Activation Softkey",
      "header": "Parfait, vous venez d'activer une nouvelle SoftKey!",
      "subtitle": "A partir de maintenant...",
      "bullet_1": " Vous pouvez connecter et passer des ordres de bourse et des transactions",
      "paragraph_1": "Important à savoir",
      "paragraph_2": "Nous vous recommandons d'activer la SoftKey sur un appareil supplémentaire (smartphone ou tablette). Vous pouvez en activer autant que vous le désirez.",
      "paragraph_3": "Vous pourrez toujours ajouter ultérieurement un appareil supplémentaire via le menu Préférences > Sécurité > Authentification > Demander une nouvelle Softkey.",
      "button_label": "Connectez avec votre Softkey"
    },
    "404": {
      "title": "Oups",
      "subtitle": "Veuillez ressayer en vous assurant des points suivants :",
      "reason_one": "Avoir entrer le bon login (ex: KEYTXXXXXX)",
      "reason_two": "Lancer la procédure sur la même connection internet",
      "reason_three": "Créer le profile sur l'application Keytradebank sur le même téléphone que votre itsme.",
      "final_paragraph": "Si le probleme persiste, veuillez contacter le ",
      "link_title": "service client.",
      "link": "https://www.keytradebank.be/fr/contactez-nous",
      "button_label": "Réessayer"
    }
  },
  "nl": {
    "home_screen": {
      "title": "Geen toegang meer?",
      "subtitle": "We helpen u een nieuwe Softkey te activeren met itsme®",
      "username_label": "Keytrade gebruikersnaam/logon",
      "username_placeholder": "ex: KEYTXXXXXX",
      "continue": "Ga verder",
      "link_manual_activation": "Gebruikersnaam/logon vergeten?",
      "link_manual_activation_href": "https://www.keytradebank.be/nl/hulp/request-new-logon-hardkey-or-softkey"
    },
    "redirect_screen": {
      "title": "Geen toegang meer?",
      "itsmeBtn": "Identificeer met itsme®",
      "subtitle": "Identificeer jezelf met itsme® om een nieuwe Softkey op je mobiel toestel te activeren",
      "no_itsme": "Ik heb geen itsme®",
      "no_itsme_href": "https://www.itsme-id.com/nl-BE/get-started"
    },
    "cronto": {
      "title": "Softkey activatie",
      "activate_softkey": "Activeer je Softkey",
      "play_store_url": "https://play.google.com/store/apps/details?id=be.keytradebank.phone&hl=nl",
      "app_store_url": "https://apps.apple.com/be/app/keytrade-bank/id640974593?l=nl",
      "bullet_1": "[b]Neem het mobiel[/b] toestel waarop u een extra SoftKey wil installeren",
      "bullet_2": "Open of Download de app [b]«Keytrade Bank: Banking & Trading»[/b]",
      "bullet_3": "Maak [b]een profiel[/b] aan",
      "bullet_4": "[b]Kies een naam en een foto[/b] voor uw profiel",
      "bullet_5": "Geef [b]uw gebruikersnaam[/b] in",
      "bullet_6": "Selecteer [b]«SoftKey»[/b]",
      "bullet_7": "Creëer en bevestig [b]uw pincode[/b]",
      "bullet_8": "[b]Scan de beveiligde QR-code[/b] hieronder",
      "30_minutes_valid": "Deze QR code blijft 30 minuten geldig",
      "disclaimer": "Let op, zorg dat niemand de QR-code scant met een ander apparaat!",
      "retry": "Opnieuw proberen"
    },
    "success": {
      "title": "Softkey activatie",
      "header": "Perfect, u heeft een nieuwe Softkey geactiveerd!",
      "subtitle": "Vanaf nu",
      "bullet_1": " Kan u met de Softkey inloggen alsook beursorders of overschrijvingen bevestigen",
      "paragraph_1": "Belangrijk om weten",
      "paragraph_2": "Wij adviseren om de Softkey op een bijkomend toestel (smartphone of tablet) te activeren. Je kan er zo veel activeren als je maar wil. ",
      "paragraph_3": "Je kan steeds een bijkomend toestel activeren via het menu Voorkeuren > Beveiliging > Authenticatie > Een nieuwe Softkey aanvragen.",
      "button_label": "Log in met je Softkey"
    },
    "404": {
      "title": "Oeps",
      "subtitle": "Probeer het opnieuw en let op de volgende punten: ",
      "reason_one": "U heeft de juiste login ingevoerd (bijvoorbeeld: KEYTXXXXXX)",
      "reason_two": "Start de procedure op dezelfde internetverbinding",
      "reason_three": "Maak het profiel aan in de Keytradebank-applicatie op dezelfde telefoon als uw itsme.",
      "final_paragraph": "Als het probleem aanhoudt, neem dan contact op",
      "link_title": "contact center.",
      "link": "https://www.keytradebank.be/nl/contacteer-ons",
      "button_label": "Opnieuw proberen "
    }
  }
};
const GlobalStyle = ft`
  strong {
    font-weight: bold !important;
    font-size: inherit;
  }
`;
const SpinnerContainer = dt.div`
  margin: 150px auto;
  width: 100%;
  text-align: center;
`;
const SoftkeyRecovery = _ref11 => {
  let {
    labels,
    lang = 'en',
    env = "test"
  } = _ref11;
  const [isLoading, setIsLoading] = React.useState(true);
  const softkeyStore = useSoftkeyStore();
  React.useEffect(() => {
    setIsLoading(true);
    if (env) {
      softkeyStore.setEnv(env);
    }
    if (!labels) {
      softkeyStore.setLabels(fallbackLabels[lang]);
    } else {
      softkeyStore.setLabels(labels);
    }
    if (lang) {
      softkeyStore.setLanguage(lang);
    }
    setIsLoading(false);
  }, [labels, lang, env]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(componentsLoader.LoaderSpinner, null)) : /*#__PURE__*/React.createElement(AppProvider, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(AppRouter, null)));
};
module.exports = SoftkeyRecovery;